<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <!-- 탭 헤더 -->
            <v-toolbar color="grey lighten-5" flat class="elevation-1" dense>
                <!-- PC: 탭 / 모바일: 드롭다운 -->
                <v-tabs
                    v-if="!isMobileTab"
                    v-model="activeTab"
                    color="primary"
                    slider-color="primary"
                    background-color="transparent"
                    icons-and-text
                    show-arrows
                    class="flex-grow-1"
                >
                    <v-tab v-for="tab in tabItems" :key="tab.value" class="tab-item">
                        <span class="tab-text">{{ tab.text }}</span>
                        <v-icon class="ml-2" size="20">{{ tab.icon }}</v-icon>
                    </v-tab>
                </v-tabs>
                <v-select
                    v-else
                    v-model="activeTab"
                    :items="tabItems"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    color="primary"
                    class="tab-select flex-grow-1 my-2"
                    :menu-props="{ offsetY: true, maxHeight: 400 }"
                >
                    <template v-slot:selection="{ item }">
                        <v-icon size="18" color="primary" class="mr-2">{{ item.icon }}</v-icon>
                        <span class="tab-text">{{ item.text }}</span>
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-icon class="mr-3">
                                <v-icon size="20" color="primary">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-select>
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :href="url"
                            target="_blank"
                            rel="noopener noreferrer"
                            color="lime accent-3"
                            rounded
                            elevation="2"
                            x-small
                            class="mr-2"
                        >
                            <v-icon left color="black" small>mdi-open-in-new</v-icon>
                            <span class="black--text text-caption">링크 열기</span>
                        </v-btn>
                    </template>
                    <span>새 탭에서 서버 상태 JSON 열기</span>
                </v-tooltip>
            </v-toolbar>

            <!-- 탭 패널 -->
            <v-tabs-items v-model="activeTab" :touchless="isMobileTab">
                <!-- 1번 탭: 기본 설정 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-cog</v-icon>
                            <span class="toolbar-text">기본 서버 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-container fluid class="pa-3">
                        <!-- 1. 서버 관리 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-server</v-icon>
                                서버 관리
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field label="게임이름" v-model="gameName" dense outlined hide-details class="mb-2"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="AOS 최신 버전" v-model="aosVer" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="IOS 최신 버전" v-model="iosVer" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="AOS 최소 버전" v-model="aosVer_Min" style="background-color: #E53935;" dark dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="IOS 최소 버전" v-model="iosVer_Min" style="background-color: #E53935;" dark dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 2. 서버 점검 상태 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-tools</v-icon>
                                서버 점검 상태
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-select
                                            v-model="selected_server_state_aos"
                                            :items="serverStateInfoList"
                                            item-text="name"
                                            item-value="value"
                                            label="AOS 서버상태"
                                            @change="Refresh_ItemInfo"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                            v-model="selected_server_state_ios"
                                            :items="serverStateInfoList"
                                            item-text="name"
                                            item-value="value"
                                            label="IOS 서버상태"
                                            @change="Refresh_ItemInfo"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense v-if="IsSever_Checking()">
                                    <v-col cols="12">
                                        <v-text-field
                                            label="점검 메시지"
                                            v-model="server_checking_message"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 3. 검수 진행버전 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-check-circle</v-icon>
                                검수 진행버전 (Default = "")
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="AOS 검수 버전" v-model="aosVer_Check" style="background-color: #BBDEFB;" hint="검수중인 버전이 없는경우 비워두세요." persistent-hint dense outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="IOS 검수 버전" v-model="iosVer_Check" style="background-color: #BBDEFB;" hint="검수중인 버전이 없는경우 비워두세요." persistent-hint dense outlined></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 쿠팡배너 링크 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold orange lighten-5">
                                <v-icon left size="18">mdi-link-variant</v-icon>
                                쿠팡배너 링크
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-text-field label="쿠팡 배너 URL" v-model="coupang_banner_link" placeholder="쿠팡 배너 URL을 입력하세요" dense outlined hide-details></v-text-field>
                            </v-card-text>
                        </v-card>

                        <!-- 4. 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-cog</v-icon>
                                설정
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-select
                                            v-model="selected_event_state_review"
                                            :items="serverStateEventInfo"
                                            item-text="name"
                                            item-value="value"
                                            label="리뷰이벤트"
                                            @change="Refresh_ItemInfo"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-select
                                            v-model="activation_coin_shop"
                                            :items="serverStateEventInfo"
                                            item-text="name"
                                            item-value="value"
                                            label="코인 교환소"
                                            @change="Refresh_ItemInfo"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <!-- (PNJ) 쿠폰교환소 — 신규 (CMS 쿠폰 플레이스먼트 코드 입력) -->
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="(PNJ)쿠폰교환소" v-model="pnj_coupon_shop_type" placeholder="예: main_shop" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="(PNJ)쿠폰교환소 검수전용" v-model="pnj_coupon_shop_type_review" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- 영상광고 쿨타임(초) — 신규, 기본 1200 -->
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field
                                            label="영상광고 쿨타임(초)"
                                            v-model.number="video_ad_cooltime"
                                            type="number"
                                            hint="영상 광고 재노출 쿨타임(기본 1200초)"
                                            persistent-hint
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="전화번호 인증 이메일" v-model="phone_verify_email" placeholder="예: verify@pnjstudio.com" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="문의사항 이메일" v-model="inquiry_email" placeholder="예: help@pnjstudio.com" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 2번 탭: 이벤트 설정 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-star</v-icon>
                            <span class="toolbar-text">이벤트 및 마케팅 설정</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-container fluid class="pa-3">
                        <!-- 5-1. 일간 챌린지 스냅 플레이스먼트 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold amber lighten-5">
                                <v-icon left size="18" color="amber darken-2">mdi-calendar-star</v-icon>
                                일간 챌린지 스냅 플레이스먼트
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field label="일간 챌린지 스냅 플레이스먼트" v-model="daily_challenge_snap_placement" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 5-2. 데일리 이벤트 카운트 설정 (일일 오퍼월 챌린지 카운트) -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold amber lighten-5">
                                <v-icon left size="18" color="amber darken-2">mdi-counter</v-icon>
                                데일리 이벤트 카운트 설정
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            v-model.number="daily_offerwall_challenge_count"
                                            type="number"
                                            min="0"
                                            label="일일 오퍼월 챌린지 카운트"
                                            dense outlined hide-details
                                            prepend-inner-icon="mdi-counter"
                                        ></v-text-field>
                                        <div class="text-caption grey--text mt-1">DAILY_OFFERWALL_CHALLENGE_COUNT · 현재 값: <code>{{ daily_offerwall_challenge_count }}</code></div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 6. Home API 플레이스먼트 -->
                        <!-- <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold green lighten-5">
                                <v-icon left size="18" color="green">mdi-gamepad-variant</v-icon>
                                Home API 플레이스먼트
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field label="Home API 플레이스먼트" v-model="home_api_placement" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card> -->

                        <!-- 6. 리뷰이벤트 링크 설정 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-link</v-icon>
                                리뷰이벤트 링크 설정
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field label="AOS 리뷰이벤트 링크" v-model="review_event_link_aos" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field label="IOS 리뷰이벤트 링크" v-model="review_event_link_ios" dense outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 7. 스탬프이벤트 관리 (참여 가능 오퍼월/충전소) -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold purple lighten-5 d-flex align-center">
                                <v-icon left size="18" color="purple">mdi-stamper</v-icon>
                                스탬프이벤트 관리
                                <span class="text-caption grey--text ml-2">· 스탬프이벤트에 참여할 강화소를 '강화소 정렬 관리'에서 선택</span>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense align="center">
                                    <v-col cols="12" md="10">
                                        <v-select v-model="newStampSelection" :items="availableStampV2Items()" item-text="label" item-value="id" label="강화소 선택 (강화소 정렬 관리에서)" dense outlined hide-details clearable></v-select>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-btn color="purple" dark block :disabled="!newStampSelection" @click="addStampOfferwall">
                                            <v-icon left small>mdi-plus</v-icon>추가
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider class="my-2" />
                                <draggable v-model="stamp_event_offerwall_list" handle=".stamp-drag-handle">
                                    <v-list-item
                                        v-for="(ofw, sidx) in stamp_event_offerwall_list"
                                        :key="'stamp-' + (ofw.id || sidx)"
                                        :class="{'point-tab-item-inactive': ofw.is_active !== 'Y'}"
                                        :style="ofw.is_active !== 'Y' ? 'background-color: #f5f5f5; opacity: 0.7; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;' : 'border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;'"
                                    >
                                        <v-icon class="stamp-drag-handle mr-2" color="grey">mdi-drag</v-icon>
                                        <v-list-item-avatar tile size="36" color="grey lighten-3">
                                            <img v-if="(lookupV2Item(ofw.id) || {}).icon" :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+(lookupV2Item(ofw.id) || {}).icon" alt="아이콘" style="object-fit: cover;">
                                            <v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-body-2">
                                                {{ lookupV2Name(ofw.id) }}
                                                <v-chip v-if="!lookupV2Item(ofw.id)" x-small color="red lighten-4" text-color="red darken-2" class="ml-1">삭제된 강화소</v-chip>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="text-caption">
                                                태그: {{ (lookupV2Item(ofw.id) || {}).tag || '-' }} · 키: {{ (lookupV2Item(ofw.id) || {}).placement_key || '-' }} | 상태: {{ ofw.is_active === 'Y' ? '활성화' : '비활성화' }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action class="d-flex flex-row align-center">
                                            <v-btn icon small @click="toggleStampOfferwallActive(sidx)" :color="ofw.is_active === 'Y' ? 'success' : 'grey'">
                                                <v-icon>{{ ofw.is_active === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                            </v-btn>
                                            <v-btn icon small color="red" @click="removeStampOfferwall(sidx)"><v-icon>mdi-delete</v-icon></v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </draggable>
                                <v-container v-if="stamp_event_offerwall_list.length === 0" class="text-center py-2">
                                    <v-icon large color="grey lighten-1" class="mb-2">mdi-stamper</v-icon>
                                    <p class="text-body-2 grey--text mb-0">참여 오퍼월이 없습니다. 위에서 추가하세요.</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 5번 탭: 데이터 관리 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom">
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-database</v-icon>
                            <span class="toolbar-text">데이터 관리</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-container fluid class="pa-3">
                        <!-- 부스터 퀘스트 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-rocket-launch</v-icon>
                                부스터 퀘스트
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <v-row dense align="center">
                                    <v-col cols="12" md="6">
                                        <v-file-input
                                            label="booster_quest.json 파일업로드"
                                            v-model="boosterQuestFile"
                                            :multiple="false"
                                            accept=".json,application/json"
                                            outlined
                                            dense
                                            hide-details
                                            @change="onFileChange_BoosterQuest"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6" class="d-flex align-center">
                                        <v-btn
                                            color="blue-grey darken-1"
                                            dark
                                            small
                                            @click="openBoosterQuestLink"
                                            class="mr-2"
                                        >
                                            <v-icon left small>mdi-open-in-new</v-icon>
                                            링크 보기
                                        </v-btn>
                                        <v-btn
                                            v-if="enableUpload_BoosterQuest"
                                            color="lime accent-3"
                                            @click="upload_BoosterQuest"
                                            :loading="loadingBoosterQuest"
                                        >
                                            <v-icon left>mdi-upload</v-icon>
                                            업로드
                                        </v-btn>
                                        <v-btn v-else color="grey" style="color: white; font-weight: 700;" disabled>
                                            <v-icon left>mdi-upload</v-icon>
                                            업로드
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- 부스터 퀘스트 오퍼월 타입 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">
                                <v-icon left size="18">mdi-tag-multiple</v-icon>
                                부스터 퀘스트 오퍼월 타입
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <div class="text-caption grey--text mb-2">
                                    퀘스트 상태가 오퍼월임을 클라이언트에 알려, 해당 상태일 때만 갱신하여 서버 부담을 줄이기 위한 타입 리스트
                                </div>
                                <v-row dense align="center" class="mb-2">
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            label="타입 키 입력"
                                            placeholder="예: rewarded_video"
                                            v-model="newOfferwallType"
                                            outlined
                                            dense
                                            hide-details
                                            @keyup.enter="addOfferwallType"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-btn
                                            color="primary"
                                            small
                                            @click="addOfferwallType"
                                            :disabled="!newOfferwallType || !newOfferwallType.trim()"
                                        >
                                            <v-icon left small>mdi-plus</v-icon>
                                            추가
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-chip
                                    v-for="(item, idx) in boosterQuestOfferwallTypes"
                                    :key="'offerwall-type-' + idx"
                                    close
                                    class="ma-1"
                                    color="blue-grey lighten-4"
                                    @click:close="removeOfferwallType(idx)"
                                >
                                    {{ item }}
                                </v-chip>
                                <div v-if="boosterQuestOfferwallTypes.length === 0" class="grey--text text--lighten-1 pa-2">
                                    등록된 타입이 없습니다.
                                </div>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 6번 탭: 광고관리 -->
                <v-tab-item>
                    <v-container fluid>
                        <!-- 전면광고 관리 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold indigo lighten-5">
                                <v-icon left size="18" color="indigo">mdi-bullhorn</v-icon>
                                전면광고 관리
                                <span class="text-caption grey--text ml-2">플레이스먼트별 전면광고 타입 설정</span>
                            </v-card-subtitle>
                            <v-card-text class="pa-0">
                                <template v-for="(p, i) in interstitial_placements">
                                    <v-divider v-if="i > 0" :key="p.key + '_div'"></v-divider>
                                    <div :key="p.key" class="d-flex align-center flex-wrap px-4 py-3">
                                        <div class="flex-grow-1 mr-4" style="min-width: 200px;">
                                            <div class="text-subtitle-2 font-weight-bold">{{ p.label }}</div>
                                            <div class="text-caption grey--text mt-1">{{ p.desc }}</div>
                                        </div>
                                        <div style="width: 240px;">
                                            <v-select
                                                v-model="ad_placement_values[p.key]"
                                                :items="interstitial_ad_type_options"
                                                item-text="text"
                                                item-value="value"
                                                placeholder="광고 타입 선택"
                                                outlined
                                                dense
                                                hide-details
                                                clearable
                                            ></v-select>
                                        </div>
                                    </div>
                                </template>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 7번 탭: 메뉴관리 -->
                <v-tab-item>
                    <v-container fluid class="pa-3">
                        <!-- 플레이스먼트 (PLACEMENT_LIST) — 태그는 등록 후 변경 불가 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold teal lighten-5 d-flex align-center">
                                <v-icon left size="18" color="teal">mdi-map-marker-radius</v-icon>
                                플레이스먼트
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="teal" x-small fab v-bind="attrs" v-on="on" @click="openPlacementDialog()" class="ml-2">
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>플레이스먼트 추가</span>
                                </v-tooltip>
                                <span class="text-caption grey--text ml-2">· 태그는 등록 후 변경·삭제 불가 (플레이스먼트 키·설명만 수정 가능)</span>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <div
                                    v-for="(pl, pidx) in placement_list"
                                    :key="pl.tag"
                                    class="d-flex align-center flex-wrap px-2 py-2 mb-2"
                                    style="border: 1px solid #e0e0e0; border-radius: 4px;"
                                >
                                    <v-chip small color="teal lighten-4" text-color="teal darken-3" class="mr-3 font-weight-bold">{{ pl.tag }}</v-chip>
                                    <div class="flex-grow-1" style="min-width: 0;">
                                        <div class="text-body-2">키: <code>{{ pl.placement_key || '-' }}</code> · 카운트: <code>{{ pl.count }}</code></div>
                                        <div class="text-caption grey--text text-truncate">{{ pl.description || '설명 없음' }}</div>
                                    </div>
                                    <v-btn icon small color="primary" @click="openPlacementDialog(pidx)"><v-icon>mdi-pencil</v-icon></v-btn>
                                </div>
                                <v-container v-if="placement_list.length === 0" class="text-center">
                                    <v-icon large color="grey lighten-1" class="mb-3">mdi-map-marker-off-outline</v-icon>
                                    <p class="text-body-2 grey--text">등록된 플레이스먼트가 없습니다. 추가 버튼을 눌러 등록하세요.</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 오늘의 숙제 리스트 -->
                        <v-card outlined class="mb-3">
                            <v-card-subtitle class="py-2 font-weight-bold deep-purple lighten-5 d-flex align-center">
                                <v-icon left size="18" color="deep-purple">mdi-clipboard-check-outline</v-icon>
                                오늘의 숙제 리스트
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="deep-purple" x-small fab v-bind="attrs" v-on="on" @click="openHomeworkDialog()" class="ml-2">
                                            <v-icon color="white" small>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>숙제 추가</span>
                                </v-tooltip>
                                <span class="text-caption grey--text ml-2">· 드래그로 순서를 조정할 수 있습니다</span>
                            </v-card-subtitle>
                            <v-card-text class="pa-3">
                                <draggable v-model="homework_list" handle=".hw-drag-handle">
                                    <v-card v-for="(hw, hidx) in homework_list" :key="hw.id || ('hw-' + hidx)" outlined class="mb-2">
                                        <div class="d-flex align-center pa-2">
                                            <v-icon class="hw-drag-handle mr-2" color="grey" title="드래그해서 순서 변경">mdi-drag</v-icon>
                                            <v-avatar tile size="44" color="grey lighten-3" class="mr-3">
                                                <img v-if="hw.thumb" :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+hw.thumb" alt="썸네일" style="object-fit: cover;">
                                                <v-icon v-else color="grey lighten-1">mdi-image-off-outline</v-icon>
                                            </v-avatar>
                                            <div class="flex-grow-1" style="min-width:0;">
                                                <div class="font-weight-bold text-truncate">{{ hw.title || '(제목 없음)' }}</div>
                                                <div class="text-caption grey--text text-truncate">
                                                    <v-chip x-small :color="homeworkTypeChipColor(hw.type)" text-color="white" class="mr-1">{{ homeworkTypeLabel(hw.type) }}</v-chip>
                                                    <template v-if="hw.type === 'CUSTOM'">키: {{ hw.custom_key || '-' }}</template>
                                                    <template v-else-if="hw.type === 'OFFERWALL'">오퍼월: {{ hw.offerwall_type || '-' }}<span v-if="hw.placement_key"> · 플레이스먼트: {{ hw.placement_key }}</span><span v-if="hw.campaign_key"> · 캠페인: {{ hw.campaign_key }}</span></template>
                                                    <template v-else-if="hw.type === 'LINK'">링크: {{ hw.link_url || '-' }}</template>
                                                </div>
                                            </div>
                                            <v-btn icon small color="primary" @click="openHomeworkDialog(hidx)"><v-icon>mdi-pencil</v-icon></v-btn>
                                            <v-btn icon small color="red" @click="deleteHomework(hidx)"><v-icon>mdi-delete</v-icon></v-btn>
                                        </div>
                                    </v-card>
                                </draggable>
                                <v-container v-if="homework_list.length === 0" class="text-center">
                                    <v-icon large color="grey lighten-1" class="mb-3">mdi-clipboard-text-off-outline</v-icon>
                                    <p class="text-body-2 grey--text">등록된 숙제가 없습니다. 추가 버튼을 눌러 등록하세요.</p>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- 저장 버튼 -->
                        <v-card outlined>
                            <v-card-text class="pa-3 text-center">
                                <v-btn color="lime accent-3" width="150px" @click="OnSaveDone">
                                    <v-icon left>mdi-content-save</v-icon>
                                    전체 저장
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-tab-item>

                <!-- 간단미션 등록/수정 다이얼로그 -->
                <v-dialog v-model="simpleMissionDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingSimpleMissionIndex >= 0 ? '간단미션 수정' : '간단미션 등록' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense align="center">
                                    <v-col cols="12" md="4">
                                        <div class="text-caption mb-1">아이콘 (128x128)</div>
                                        <img 
                                            v-if="editingSimpleMission.icon"
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingSimpleMission.icon" 
                                            alt="아이콘"  
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                        >
                                        <v-icon v-else size="64" color="grey lighten-1">mdi-image-off</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-file-input
                                            label="아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="editingSimpleMission.iconFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleSimpleMissionIconChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="타이틀"
                                            v-model="editingSimpleMission.title"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="플레이스먼트"
                                            v-model="editingSimpleMission.placement"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-textarea
                                            label="설명 텍스트"
                                            v-model="editingSimpleMission.description"
                                            rows="3"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingSimpleMission.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closeSimpleMissionDialog">취소</v-btn>
                            <v-btn color="primary" text @click="saveSimpleMission">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 메인페이지 서브 메뉴 등록/수정 다이얼로그 -->
                <v-dialog v-model="mainSubmenuDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingMainSubmenuIndex >= 0 ? '서브 메뉴 수정' : '서브 메뉴 등록' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense align="center">
                                    <v-col cols="12" md="4">
                                        <div class="text-caption mb-1">아이콘 (128x128)</div>
                                        <img 
                                            v-if="editingMainSubmenu.icon"
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingMainSubmenu.icon" 
                                            alt="아이콘"  
                                            style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                        >
                                        <v-icon v-else size="64" color="grey lighten-1">mdi-image-off</v-icon>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-file-input
                                            label="아이콘 업로드 (128x128)"
                                            accept="image/*"
                                            v-model="editingMainSubmenu.iconFile"
                                            prepend-icon="mdi-image"
                                            dense
                                            outlined
                                            hide-details
                                            @change="handleMainSubmenuIconChange"
                                        ></v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="타이틀"
                                            v-model="editingMainSubmenu.title"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="TAG (고유 키값)"
                                            v-model="editingMainSubmenu.tag"
                                            hint="항목 식별용 고유 텍스트 키"
                                            persistent-hint
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="타입"
                                            v-model="editingMainSubmenu.type"
                                            :items="[{text: '링크', value: 'LINK'}, {text: '플레이스먼트', value: 'PLACEMENT'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            :label="editingMainSubmenu.type === 'LINK' ? '경로 (링크 URL)' : '경로 (플레이스먼트 키값)'"
                                            v-model="editingMainSubmenu.path"
                                            :hint="editingMainSubmenu.type === 'LINK' ? '링크 URL을 입력하세요' : '플레이스먼트 키값을 입력하세요'"
                                            persistent-hint
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingMainSubmenu.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closeMainSubmenuDialog">취소</v-btn>
                            <v-btn color="primary" text @click="saveMainSubmenu">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 포인트탭 아이템 등록/수정 다이얼로그 -->
                <v-dialog v-model="pointTabItemDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingPointTabItemIndex >= 0 ? '아이템 수정' : '아이템 등록' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="이름"
                                            v-model="editingPointTabItem.name"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="태그"
                                            v-model="editingPointTabItem.tag"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingPointTabItem.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closePointTabItemDialog">취소</v-btn>
                            <v-btn color="primary" text @click="savePointTabItem">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 포인트탭 아이템 V2 등록/수정 다이얼로그 -->
                <v-dialog v-model="pointTabItemDialogV2" max-width="720px" :fullscreen="$vuetify.breakpoint.xsOnly">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ editingPointTabItemIndexV2 >= 0 ? '아이템 수정 (V2)' : '아이템 등록 (V2)' }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12">
                                        <div class="text-caption mb-1">아이콘 (128x128)</div>
                                        <div class="d-flex align-center">
                                            <img
                                                v-if="editingPointTabItemV2.icon"
                                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingPointTabItemV2.icon"
                                                alt="아이콘"
                                                style="width: 64px; height: 64px; border: 2px solid #ddd; border-radius: 8px; object-fit: cover;"
                                                class="mr-3"
                                            >
                                            <v-icon v-else size="64" color="grey lighten-1" class="mr-3">mdi-image-off</v-icon>
                                            <v-file-input
                                                label="아이콘 업로드 (128x128)"
                                                accept="image/*"
                                                v-model="editingPointTabItemV2.iconFile"
                                                prepend-icon="mdi-image"
                                                dense
                                                outlined
                                                hide-details
                                                class="flex-grow-1"
                                            ></v-file-input>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="이름"
                                            v-model="editingPointTabItemV2.name"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="태그"
                                            v-model="editingPointTabItemV2.tag"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="플레이스먼트키 (옵션, String)"
                                            v-model="editingPointTabItemV2.placement_key"
                                            hint="태그가 같아도 이 값이 다르면 다른 강화소로 구분됩니다"
                                            persistent-hint
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select
                                            label="활성화 여부"
                                            v-model="editingPointTabItemV2.is_active"
                                            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-select
                                            label="이벤트 모드"
                                            v-model="editingPointTabItemV2.is_event_mode"
                                            :items="[{text: '이벤트 모드 ON', value: 'Y'}, {text: '일반 (OFF)', value: 'N'}]"
                                            dense
                                            outlined
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="text-caption mb-1 pink--text text--darken-2">
                                            <v-icon x-small color="pink darken-2">mdi-calendar-clock</v-icon>
                                            이벤트 기간 — 시작·종료를 모두 지정해야 활성입니다 (미설정/기간 밖이면 비활성). 이벤트 모드와 무관하게 날짜로만 판단됩니다.
                                        </div>
                                        <div class="mb-2">
                                            <v-chip
                                                v-if="getV2EventStatusChip(editingPointTabItemV2)"
                                                small
                                                :color="getV2EventStatusChip(editingPointTabItemV2).color"
                                                :text-color="getV2EventStatusChip(editingPointTabItemV2).textColor"
                                            >
                                                <v-icon left small>{{ getV2EventStatusChip(editingPointTabItemV2).icon }}</v-icon>
                                                {{ getV2EventStatusChip(editingPointTabItemV2).text }}
                                            </v-chip>
                                            <span v-else class="text-caption grey--text">기간 미설정</span>
                                        </div>
                                        <div class="text-caption grey--text mb-1">시작</div>
                                        <v-row dense align="center" class="mb-1">
                                            <v-col cols="12" sm="6">
                                                <v-menu v-model="startMenuV2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="v2StartDate"
                                                            label="날짜"
                                                            placeholder="미설정"
                                                            readonly
                                                            clearable
                                                            @click:clear="clearV2Event('event_start')"
                                                            prepend-inner-icon="mdi-calendar"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="v2StartDate" locale="ko" no-title @input="startMenuV2 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="6" sm="3">
                                                <v-select v-model="v2StartHour" :items="hourItems" label="시" dense outlined hide-details :disabled="!v2StartDate"></v-select>
                                            </v-col>
                                            <v-col cols="6" sm="3">
                                                <v-select v-model="v2StartMin" :items="minuteItems" label="분" dense outlined hide-details :disabled="!v2StartDate"></v-select>
                                            </v-col>
                                        </v-row>
                                        <div class="text-caption grey--text mb-1">종료</div>
                                        <v-row dense align="center">
                                            <v-col cols="12" sm="6">
                                                <v-menu v-model="endMenuV2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="v2EndDate"
                                                            label="날짜"
                                                            placeholder="미설정"
                                                            readonly
                                                            clearable
                                                            @click:clear="clearV2Event('event_end')"
                                                            prepend-inner-icon="mdi-calendar"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="v2EndDate" locale="ko" no-title @input="endMenuV2 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="6" sm="3">
                                                <v-select v-model="v2EndHour" :items="hourItems" label="시" dense outlined hide-details :disabled="!v2EndDate"></v-select>
                                            </v-col>
                                            <v-col cols="6" sm="3">
                                                <v-select v-model="v2EndMin" :items="minuteItems" label="분" dense outlined hide-details :disabled="!v2EndDate"></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="closePointTabItemDialogV2">취소</v-btn>
                            <v-btn color="primary" text @click="savePointTabItemV2">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 플레이스먼트 추가/수정 다이얼로그 -->
                <v-dialog v-model="placementDialog" max-width="520" persistent>
                    <v-card>
                        <v-card-title class="text-subtitle-1">{{ editingPlacementIndex >= 0 ? '플레이스먼트 수정' : '플레이스먼트 추가' }}</v-card-title>
                        <v-divider />
                        <v-card-text class="pt-4">
                            <v-text-field
                                :value="editingPlacement.tag"
                                @input="(v) => editingPlacement.tag = (v || '').toUpperCase()"
                                label="태그 (자동 대문자)"
                                :disabled="editingPlacementIndex >= 0"
                                :hint="editingPlacementIndex >= 0 ? '태그는 등록 후 변경할 수 없습니다' : '등록 후에는 변경할 수 없습니다'"
                                persistent-hint
                                dense outlined
                                class="mb-3"
                            ></v-text-field>
                            <v-text-field v-model="editingPlacement.placement_key" label="플레이스먼트 키" hint="대소문자 입력 그대로 저장 (소문자 가능)" persistent-hint dense outlined class="mb-3"></v-text-field>
                            <v-text-field
                                v-model.number="editingPlacement.count"
                                type="number"
                                label="카운트"
                                hint="기본 -1"
                                persistent-hint
                                dense outlined
                                class="mb-3"
                            ></v-text-field>
                            <v-textarea v-model="editingPlacement.description" label="설명" rows="2" auto-grow dense outlined hide-details></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="closePlacementDialog">취소</v-btn>
                            <v-btn color="primary" @click="savePlacement">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 오늘의 숙제 추가/수정 다이얼로그 -->
                <v-dialog v-model="homeworkDialog" max-width="560" persistent>
                    <v-card>
                        <v-card-title class="text-subtitle-1">{{ editingHomeworkIndex >= 0 ? '숙제 수정' : '숙제 추가' }}</v-card-title>
                        <v-divider />
                        <v-card-text class="pt-4">
                            <!-- 썸네일 -->
                            <div class="text-caption mb-1">썸네일</div>
                            <div class="d-flex align-center mb-3">
                                <img
                                    v-if="editingHomework.thumb"
                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/'+editingHomework.thumb"
                                    alt="썸네일"
                                    style="width:64px;height:64px;border:2px solid #ddd;border-radius:8px;object-fit:cover;"
                                    class="mr-3"
                                >
                                <v-icon v-else size="64" color="grey lighten-1" class="mr-3">mdi-image-off</v-icon>
                                <v-file-input
                                    label="썸네일 업로드"
                                    accept="image/*"
                                    v-model="editingHomework.thumbFile"
                                    prepend-icon="mdi-image"
                                    dense outlined hide-details
                                    class="flex-grow-1"
                                ></v-file-input>
                            </div>
                            <!-- 타이틀 -->
                            <v-text-field v-model="editingHomework.title" label="타이틀" dense outlined hide-details class="mb-3"></v-text-field>
                            <!-- 타입 -->
                            <v-select
                                v-model="editingHomework.type"
                                :items="homeworkTypeOptions"
                                item-text="text"
                                item-value="value"
                                label="타입"
                                dense outlined hide-details
                                class="mb-3"
                            ></v-select>
                            <!-- 커스텀: 고유 키값 (커스텀 간 중복 불가) -->
                            <v-text-field
                                v-if="editingHomework.type === 'CUSTOM'"
                                v-model="editingHomework.custom_key"
                                label="고유 키값 (커스텀 간 중복 불가)"
                                hint="다른 커스텀 숙제와 중복될 수 없습니다"
                                persistent-hint
                                dense outlined
                                class="mb-3"
                            ></v-text-field>
                            <!-- 오퍼월(캠페인): 오퍼월키 선택 + 플레이스먼트 + 캠페인 키값 -->
                            <template v-if="editingHomework.type === 'OFFERWALL'">
                                <v-select
                                    v-model="editingHomework.offerwall_type"
                                    :items="offerwall_key_options"
                                    label="오퍼월키 선택"
                                    dense outlined hide-details clearable
                                    class="mb-3"
                                ></v-select>
                                <v-text-field
                                    v-model="editingHomework.placement_key"
                                    label="플레이스먼트 (옵션)"
                                    dense outlined hide-details
                                    class="mb-3"
                                ></v-text-field>
                                <v-text-field
                                    v-model="editingHomework.campaign_key"
                                    label="캠페인 키값 (옵션)"
                                    dense outlined hide-details
                                    class="mb-3"
                                ></v-text-field>
                            </template>
                            <!-- 링크: 링크 주소 -->
                            <v-text-field
                                v-if="editingHomework.type === 'LINK'"
                                v-model="editingHomework.link_url"
                                label="링크 주소"
                                placeholder="https://..."
                                dense outlined hide-details
                                class="mb-3"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="closeHomeworkDialog">취소</v-btn>
                            <v-btn color="primary" @click="saveHomework">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-tabs-items>
        </v-card>

        <div class="py-2"></div>

        <v-card class="mx-auto" max-width="95%" v-if="is_using_table">
            <v-toolbar :color="'grey darken-1'" dark="dark" dense class="toolbar-custom">
                <v-toolbar-title class="subtitle-1">테이블 관리</v-toolbar-title>
            </v-toolbar>
            <v-container fluid class="pa-3">
                <v-card outlined class="mb-3">
                    <v-card-subtitle class="py-2 font-weight-bold blue lighten-5">테이블 업로드</v-card-subtitle>
                    <v-card-text class="pa-3">
                        <v-row dense align="center">
                            <v-col cols="12" md="5">
                                <v-file-input
                                    v-model="table_file"
                                    label="파일 선택"
                                    multiple
                                    prepend-icon="mdi-paperclip"
                                    dense
                                    outlined
                                    hide-details
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="템플릿 버전" 
                                    v-model="table_file_version" 
                                    dense
                                    outlined
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" class="text-right">
                                <v-btn color="lime accent-3" @click="OnSaveDone">
                                    <v-icon left>mdi-upload</v-icon>
                                    UPLOAD
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card outlined>
                    <v-data-table
                        :footer-props="{'items-per-page-options':[30, -1]}"
                        :headers="headers"
                        :items="table_list_history"
                        :loading="loadingData"
                        dense
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td>{{row.item.version}}</td>
                                <td>{{row.item.admin}}</td>
                                <td>{{row.item.update_date}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-container>
        </v-card>

    <!-- 서버 재시작 (라이브만 노출) -->
    <div v-if="isLive" class="text-center my-6">
        <v-btn color="red" dark large elevation="2" @click="onRestartServer">
            <v-icon left>mdi-restart</v-icon>
            서버 재시작
        </v-btn>
    </div>
    </div>

</template>

<script>
    import axios from 'axios'; // 먼저 axios import 필요
    import {mapActions} from 'vuex';
    import moment from 'moment'
    import store from '../../store';
    import config from '../../config/config';
    import { OFFERWALL_KEYS } from '../../config/cpu_config';
    import {format, parseISO} from 'date-fns'
import { divide } from 'lodash';
    import draggable from 'vuedraggable';
    const { s3_upload ,  FileUpload_Async, FileUpload_JSON } = require("../../util/fileutil");
    export default {
        name: 'UserList',

        data: () => ({
            activeTab: 0, // 탭 인덱스
            // 탭 정의 (PC는 v-tabs, 모바일은 v-select 로 동일 데이터 사용)
            tabItems: [
                { value: 0, text: '기본 설정',    icon: 'mdi-cog' },
                { value: 1, text: '이벤트 설정',  icon: 'mdi-star' },
                { value: 2, text: '데이터 관리',  icon: 'mdi-database' },
                { value: 3, text: '광고관리',     icon: 'mdi-bullhorn' },
                { value: 4, text: '메뉴관리',     icon: 'mdi-menu' },
            ],
            serverTime:'0000-00-00 00:00:00',
            date:moment().format('yyyy-MM-DD'),
         
            server_state_info: {
                    "server_state": {
                        "PID": 1,
                        "PACKAGE": "io.snapplay.cpu",
                        "NAME": "채굴",
                        "VERSION_AOS": "1",
                        "VERSION_IOS": "1",
                        "SERVER_STATE_AOS": "1",
                        "SERVER_STATE_IOS": "1",
                        "GAME_STATE": "dev",
                        "SERVICE_OPTION": {
                        "item_opt": [
                            {
                            "key": "10001",
                            "name": "CPU 증가 보너스 포인트"
                            }
                        ]
                        }
                    }
            },
            loadingData: false,


            package_name:'io.snapplay.cpu',
            gameName:'코인 채굴기',       
            is_using_table: false,
            
            aosVer: '',             //aos 그냥 최신 버전만 안내 
            iosVer: '',             //ios 그냥 최신 버전만 안내 
            aosVer_Min: '',         //aos 최소 요구버전 이것보다 낮으면 업데이트 요청
            iosVer_Min: '',         //ios 최소 요구버전 이것보다 낮으면 업데이트 요청 
            aosVer_Check: '',       //aos 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            iosVer_Check: '',       //ios 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            // 옛 호환용 — 저장 시 ACTIVATION_EVENT_INFO 에서 파생해 같이 보내준다
            activation_event_link:'',
            activation_event_thumb:'',
            // 신규 통합 객체: is_active / action_type / param / sub_param / thumb
            activation_event_info: {
                is_active: 'N',
                action_type: 'LINK',
                param: '',
                sub_param: '',
                thumb: '',
            },
            actionTypeOptions: [
                { text: '링크 (LINK)',                value: 'LINK' },
                { text: '오퍼월 (OFFERWALL)',          value: 'OFFERWALL' },
                { text: '스냅 플레이스먼트 (PLACEMENT)', value: 'PLACEMENT' },
                { text: '스냅 캠페인 (CAMPAIGN)',       value: 'CAMPAIGN' },
            ],

            // 채굴탭 행성 링크 이벤트 (MINING_PLANET_LINK_EVENT)
            mining_planet_link_event: {
                is_active: 'N',
                action_type: 'LINK',
                param: '',
                sub_param: '',
                thumb: '',
                start_date: '',
                end_date: '',
            },
            mining_planet_link_event_ImageFile: null,
            // 오퍼월 키 목록 (공통 config cpu_config.js 에서 관리)
            offerwall_key_options: OFFERWALL_KEYS,
            activation_main_offerwall_banner:"N",
            serverStateInfoList: [
                {
                    name: '정상 작동中',
                    value: '1'
                }, {
                    name: '서버 점검中',
                    value: '2'
                }
            ],
            serverStateEventInfo: [
                {
                    name: '활성화',
                    value: 'Y'
                }, {
                    name: '비활성화',
                    value: 'N'
                }
            ],
            event_offerwall_guide_grade: [
                {
                    name: '초급',
                    value: '1'
                }, {
                    name: '중급',
                    value: '2'
                },
                {
                    name: '고급',
                    value: '3'
                }
            ],
            event_offerwall_guide_reward: [
                {
                    name: '보통',
                    value: '1'
                }, {
                    name: '많음',
                    value: '2'
                },{
                    name: '엄청많음',
                    value: '3'
                }
            ],

            event_offerwall_guide_placement: "",

            selected_server_state_aos: '1', //aos 서버 점검 상태 라이브 : 1 , 점검 : 2
            selected_server_state_ios: '1', //ios 서버 점검 상태 라이브 : 1 , 점검 : 2
            event_offerwall_guide_list : [{ placement: '', grade: '', reward: '' }], //오퍼월 유도 설정 리스트 
            event_offerwall_guide_list_count: 1, //리뷰 이벤트 활성화 상태
            //selected_event_offerwall_guide





            server_checking_message: '죄송합니다. 지금은 잠시 서버 점검중입니다.',
            item_opt:[  {
                            "key": "10001",
                            "name": "CPU 증가 보너스 포인트"
                            }],
            table_file: [],
            table_file_version: "1.0.0",
            shop_product_type:"",             
            shop_product_type_review:"",
            pnj_coupon_shop_type:"",
            pnj_coupon_shop_type_review:"",
            video_ad_cooltime:1200,
            offerwall_recommand_key:"cpu_영자추천2",
            daily_placement_key:"",
            daily_placement_game_key:"",
            daily_challenge_snap_placement:"",
            daily_offerwall_challenge_count: 8,   // 데일리 이벤트 카운트 (DAILY_OFFERWALL_CHALLENGE_COUNT, 기본 8)
            home_api_placement:"",
            event_thumb_ImageFile:null,
            activation_coin_shop:"",
            selected_event_state_review:"N",
            enable_event_popup_start: "Y",
            review_event_link_aos:"",
            review_event_link_ios:"",
            background_timer: 0,
            mallpie_enable_state: "N",
            tutorial_activation_datetime: '', // 튜토리얼 활성화 시각 (YYYY-MM-DD HH:mm:ss)
            baseUrl:'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/mandoora/manage/live/ServerState.json',
            
            // 포인트탭 관리
            simple_mission_list: [],
            recommend_point_placement: '',
            point_tab_item_list: [],
            point_tab_item_list_v2: [],
            // 카테고리 관리 (강화소를 카테고리로 묶어 정렬) — 강화소는 V2 를 id 로 참조
            point_tab_category_list: [],   // [{ id, name, description, items: [v2_id, ...] }]
            categoryDialog: false,
            editingCategory: { name: '', description: '' },
            editingCategoryIndex: -1,
            addItemSelection: {},          // { [categoryIndex]: 선택된 v2 id }
            // 이벤트 리스트 관리 (카테고리와 동일 구조 — 오퍼월 아이템(V2)을 id 로 참조)
            point_tab_event_list: [],      // [{ id, name, description, item_id }]  (오퍼월 아이템 1개만)
            eventDialog: false,
            editingEvent: { name: '', description: '', item_id: null },
            editingEventIndex: -1,
            // 메뉴관리 - 오늘의 숙제 리스트 [{ id, thumb, title, type, custom_key, offerwall_type, placement_key, link_url }]
            // 메뉴관리 - 플레이스먼트 [{ tag(대문자, 변경불가), placement_key, count(기본 -1), description }]
            placement_list: [],
            placementDialog: false,
            editingPlacement: { tag: '', placement_key: '', count: -1, description: '' },
            editingPlacementIndex: -1,
            homework_list: [],
            homeworkDialog: false,
            editingHomework: { thumb: '', thumbFile: null, title: '', campaign_key: '', type: 'CUSTOM', custom_key: '', offerwall_type: '', placement_key: '', link_url: '' },
            editingHomeworkIndex: -1,
            homeworkTypeOptions: [
                { text: '커스텀', value: 'CUSTOM' },
                { text: '오퍼월', value: 'OFFERWALL' },
                { text: '링크', value: 'LINK' },
            ],
            // 스탬프이벤트 관리 (참여 가능 오퍼월/충전소)
            stamp_event_offerwall_list: [],   // [{ id, is_active }]  (강화소 V2 참조)
            newStampSelection: null,          // 추가할 V2 강화소 id
            pointTabItemDialog: false,
            pointTabItemDialogV2: false,
            editingPointTabItem: { name: '', tag: '', is_active: 'Y' },
            editingPointTabItemIndex: -1,
            editingPointTabItemV2: { name: '', tag: '', icon: '', iconFile: null, placement_key: '', is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' },
            editingPointTabItemIndexV2: -1,
            startMenuV2: false,   // 이벤트 시작 날짜/시간 피커 메뉴
            endMenuV2: false,     // 이벤트 종료 날짜/시간 피커 메뉴
            // 간단미션 관리
            simpleMissionDialog: false,
            editingSimpleMission: { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' },
            editingSimpleMissionIndex: -1,
            // 메인페이지 서브 메뉴 관리
            main_submenu_list: [],
            mainSubmenuDialog: false,
            editingMainSubmenu: { icon: '', iconFile: null, title: '', tag: '', type: 'LINK', path: '', is_active: 'Y' },
            editingMainSubmenuIndex: -1,

            // 데이터 관리 - 부스터 퀘스트
            boosterQuestFile: null,
            enableUpload_BoosterQuest: false,
            loadingBoosterQuest: false,

            // 데이터 관리 - 부스터 퀘스트 오퍼월 타입
            boosterQuestOfferwallTypes: [],
            newOfferwallType: '',
            coupang_banner_link: '',
            phone_verify_email: '',
            inquiry_email: '',
            s3_base_path: '',
            s3_cloud_path: '',
            websocket_url: '',
            apple_rebind_enabled: 'N',   // 애플 유저아이디 바인딩 활성화 (Y/N)
            min_save_limit_enabled: 'N', // 최소저장량 제한 활성화 (Y/N)

            // 전면광고 관리 — 플레이스먼트별 광고 타입 (아래 key 를 그대로 model_server_state_info 에 저장)
            interstitial_placements: [
                { key: 'FRIEND_GATHER_AI', label: 'FRIEND_GATHER_AI', desc: 'AI 친구코인 저장하기' },
                { key: 'FRIEND_GATHER',    label: 'FRIEND_GATHER',    desc: '친구코인 저장하기' },
                { key: 'WALLET_SAVE',      label: 'WALLET_SAVE',      desc: '지갑 저장' },
                { key: 'OX_SUBMIT',        label: 'OX_SUBMIT',        desc: 'OX 선택지 고름' },
                { key: 'OX_WRONG',         label: 'OX_WRONG',         desc: 'OX 틀렸을 때' },
            ],
            interstitial_ad_type_options: [
                { text: '전면Short (ADMOB_SHORT)', value: 'ADMOB_SHORT' },
                { text: '전면Long (ADMOB_LONG)',   value: 'ADMOB_LONG' },
                { text: 'ADX 전면 (ADX_INTER)',    value: 'ADX_INTER' },
                { text: '광고 스킵 (OFF)',          value: 'OFF' },
            ],
            ad_placement_values: {
                CUP_EVENT: '',
                FRIEND_GATHER_AI: '',
                FRIEND_GATHER: '',
                WALLET_SAVE: '',
                OX_SUBMIT: '',
                OX_WRONG: '',
                TOKEN_ATTENDANCE: '',
                TOKEN_SAVE: '',
            },
        }),

        created() {
            this.LoadGameSetting();
            this.getServerTime()
        },

        methods: {
            async onRestartServer() {
                if (!confirm('서버를 재시작하시겠습니까? 진행중인 작업이 중단될 수 있습니다.')) return;
                try {
                    await this.CPU_PM2_RESTART();
                    alert('서버 재시작 요청이 완료되었습니다.');
                } catch (err) {
                    console.error(err);
                    alert('서버 재시작에 실패했습니다.');
                }
            },
            ...mapActions([
                'CPU_PM2_RESTART',
            ]),
            async LoadGameSetting() {
                const timestamp = new Date().getTime(); // 매번 다른 값
                //const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/mandoora/manage/dev/ServerState.json?t=${timestamp}`;
                const url = this.serverState_URL+`?t=${timestamp}`;
                console.log(url);
                try {
                    const response = await fetch(url, {
                        method: 'GET',
                        cache: 'no-store' // ✅ 캐시 완전 무시
                    });

                    const data = await response.json(); // ✅ 진짜 데이터 가져오기
                    console.log("데이터 불러옴"+data); // 여기서 받아온 데이터 사용
                    console.log("데이터 불러옴"+JSON.stringify(data)); // 여기서 받아온 데이터 사용
                    this.server_state_info = data;
                    this.aosVer = this.server_state_info.VERSION_AOS;
                    this.iosVer = this.server_state_info.VERSION_IOS;
                    this.aosVer_Min = this.server_state_info.VERSION_AOS_MIN;
                    this.iosVer_Min = this.server_state_info.VERSION_IOS_MIN;
                    // 강제 업데이트(최소버전) 원본 스냅샷 (저장 시 변경 확인용)
                    this._origForceVer = { aos: String(this.aosVer_Min == null ? '' : this.aosVer_Min).trim(), ios: String(this.iosVer_Min == null ? '' : this.iosVer_Min).trim() };
                    this.aosVer_Check = this.server_state_info.CHECK_VERSION_AOS;
                    this.iosVer_Check = this.server_state_info.CHECK_VERSION_IOS;
                    this.selected_server_state_aos = this.server_state_info.SERVER_STATE_AOS;
                    this.selected_server_state_ios = this.server_state_info.SERVER_STATE_IOS;
                    this.server_checking_message = this.server_state_info.SERVER_CHECKING_MSG;
                    this.activation_event_link = this.server_state_info.ACTIVATION_EVENT_LINK || '';
                    this.activation_event_thumb = this.server_state_info.ACTIVATION_EVENT_THUMB || '';
                    // ACTIVATION_EVENT_INFO 우선 로드, 없으면 옛 LINK/THUMB 에서 마이그레이션
                    const allowedActionTypes = ['LINK', 'OFFERWALL', 'PLACEMENT', 'CAMPAIGN'];
                    const rawInfo = this.server_state_info.ACTIVATION_EVENT_INFO;
                    if (rawInfo && typeof rawInfo === 'object') {
                        this.activation_event_info = {
                            is_active:   rawInfo.is_active === 'Y' ? 'Y' : 'N',
                            action_type: allowedActionTypes.includes(rawInfo.action_type) ? rawInfo.action_type : 'LINK',
                            param:       rawInfo.param || '',
                            sub_param:   rawInfo.sub_param || '',
                            thumb:       rawInfo.thumb || this.activation_event_thumb || '',
                        };
                    } else {
                        // 옛 데이터 마이그레이션: LINK 가 있으면 LINK 타입으로
                        this.activation_event_info = {
                            is_active:   this.activation_event_link ? 'Y' : 'N',
                            action_type: 'LINK',
                            param:       this.activation_event_link || '',
                            sub_param:   '',
                            thumb:       this.activation_event_thumb || '',
                        };
                    }
                    this.selected_event_state_review = this.server_state_info.ACTIVATION_EVENT_REVIEW;
                    this.activation_coin_shop = this.server_state_info.ACTIVATION_COIN_SHOP;
                    this.activation_main_offerwall_banner = this.server_state_info.ACTIVATION_MAIN_OFFERWALL_BANNER;
                    this.event_offerwall_guide_list = this.server_state_info.EVENT_OFFERWALL_GUIDE_LIST || [{ placement: '', grade: '', reward: '' }];
                    this.shop_product_type = this.server_state_info.SHOP_PRODUCT_TYPE;
                    this.shop_product_type_review = this.server_state_info.SHOP_PRODUCT_TYPE_REVIEW;                    
                    this.pnj_coupon_shop_type = this.server_state_info.PNJ_COUPON_SHOP_TYPE || "";
                    this.pnj_coupon_shop_type_review = this.server_state_info.PNJ_COUPON_SHOP_TYPE_REVIEW || "";
                    this.video_ad_cooltime = (this.server_state_info.VIDEO_AD_COOLTIME !== undefined && this.server_state_info.VIDEO_AD_COOLTIME !== null)
                        ? this.server_state_info.VIDEO_AD_COOLTIME : 1200;
                    this.enable_event_popup_start = this.server_state_info.ENABLE_EVENT_POPUP_START;
                    this.review_event_link_aos = this.server_state_info.REVIEW_EVENT_LINK_AOS;
                    this.review_event_link_ios = this.server_state_info.REVIEW_EVENT_LINK_IOS;
                    this.offerwall_recommand_key = this.server_state_info.OFFERWALL_RECOMMAND_KEY;
                    this.daily_placement_key = this.server_state_info.DAILY_PLACEMENT_KEY || '';
                    this.daily_placement_game_key = this.server_state_info.DAILY_PLACEMENT_GAME_KEY || '';
                    this.daily_challenge_snap_placement = this.server_state_info.DAILY_CHALLENGE_SNAP_PLACEMENT || '';
                    this.daily_offerwall_challenge_count = (this.server_state_info.DAILY_OFFERWALL_CHALLENGE_COUNT !== undefined && this.server_state_info.DAILY_OFFERWALL_CHALLENGE_COUNT !== null && this.server_state_info.DAILY_OFFERWALL_CHALLENGE_COUNT !== '') ? Number(this.server_state_info.DAILY_OFFERWALL_CHALLENGE_COUNT) : 8;
                    this.home_api_placement = this.server_state_info.HOME_API_PLACEMENT || '';
                    this.background_timer = this.server_state_info.BACKGROUND_TIMER || 0;
                    this.mallpie_enable_state = this.server_state_info.MALLPIE_ENABLE_STATE || 'N';
                    this.tutorial_activation_datetime = (this.server_state_info.TUTORIAL_ACTIVATION_TIME || '').trim();

                    // 채굴탭 행성 링크 이벤트 불러오기
                    const mpe = this.server_state_info.MINING_PLANET_LINK_EVENT || {};
                    this.mining_planet_link_event = {
                        is_active:   mpe.is_active === 'Y' ? 'Y' : 'N',
                        action_type: mpe.action_type || 'LINK',
                        param:       mpe.param || '',
                        sub_param:   mpe.sub_param || '',
                        thumb:       mpe.thumb || '',
                        start_date:  mpe.start_date || '',
                        end_date:    mpe.end_date || '',
                    };
                    this.mining_planet_link_event_ImageFile = null;
                    
                    // 포인트탭 관리 불러오기
                    let simpleMissionList = this.server_state_info.SIMPLE_MISSION_LIST || [];
                    // 비활성화 항목을 아래로 정렬
                    this.simple_mission_list = simpleMissionList.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.recommend_point_placement = this.server_state_info.RECOMMEND_POINT_PLACEMENT || '';
                    let pointTabItemList = this.server_state_info.POINT_TAB_ITEM_LIST || [];
                    this.point_tab_item_list = pointTabItemList.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    let pointTabItemListV2 = this.server_state_info.POINT_TAB_ITEM_LIST_V2 || [];
                    this.point_tab_item_list_v2 = pointTabItemListV2
                        .map((it, i) => ({
                            ...it,
                            // 카테고리에서 id 로 참조하므로 레거시(무 id) 아이템에 안정 id 백필
                            id: it.id || ('v2-legacy-' + i),
                            is_active: it.is_active || 'Y',
                            is_event_mode: it.is_event_mode || 'N',
                            event_start: it.event_start || '',
                            event_end: it.event_end || '',
                        }))
                        .sort((a, b) => {
                            if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                            if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                            return 0;
                        });
                    // 카테고리 관리 불러오기 (강화소는 V2 id 참조 목록)
                    this.point_tab_category_list = (this.server_state_info.POINT_TAB_CATEGORY_LIST || []).map((c, i) => ({
                        id: c.id || ('cat-legacy-' + i),
                        name: c.name || '',
                        description: c.description || '',
                        items: Array.isArray(c.items) ? c.items.slice() : [],
                    }));
                    // 이벤트 리스트 불러오기 (오퍼월 아이템은 V2 id 참조 목록)
                    this.point_tab_event_list = (this.server_state_info.POINT_TAB_EVENT_LIST || []).map((e, i) => ({
                        id: e.id || ('ev-legacy-' + i),
                        name: e.name || '',
                        description: e.description || '',
                        // 오퍼월 아이템 1개만. (구 배열 데이터가 있으면 첫 항목으로 이관)
                        item_id: e.item_id || (Array.isArray(e.items) && e.items.length ? e.items[0] : null),
                    }));
                    // 메뉴관리 - 플레이스먼트 불러오기
                    this.placement_list = (this.server_state_info.PLACEMENT_LIST || [])
                        .filter((p) => p && p.tag)
                        .map((p) => ({ tag: String(p.tag).toUpperCase(), placement_key: p.placement_key || '', count: Number.isFinite(Number(p.count)) && p.count !== '' && p.count !== null ? Number(p.count) : -1, description: p.description || '' }));
                    // 메뉴관리 - 오늘의 숙제 리스트 불러오기
                    this.homework_list = (this.server_state_info.HOMEWORK_LIST || []).map((h, i) => ({
                        id: h.id || ('hw-legacy-' + i),
                        thumb: h.thumb || '',
                        title: h.title || '',
                        type: h.type || 'CUSTOM',
                        custom_key: h.custom_key || '',
                        offerwall_type: h.offerwall_type || '',
                        placement_key: h.placement_key || '',
                        campaign_key: h.campaign_key || '',
                        link_url: h.link_url || '',
                    }));
                    // 스탬프이벤트 참여 오퍼월 불러오기
                    this.stamp_event_offerwall_list = (this.server_state_info.STAMP_EVENT_OFFERWALL_LIST || [])
                        .map((o) => ({ id: o.id || o.key || '', is_active: o.is_active || 'Y' }))
                        .filter((o) => o.id);
                    // 메인페이지 서브 메뉴 관리 불러오기
                    let mainSubmenuList = this.server_state_info.MAIN_SUBMENU_LIST || [];
                    this.main_submenu_list = mainSubmenuList.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.coupang_banner_link = this.server_state_info.COUPANG_BANNER_LINK || '';
                    this.phone_verify_email = this.server_state_info.PHONE_VERIFY_EMAIL || '';
                    this.inquiry_email = this.server_state_info.INQUIRY_EMAIL || '';
                    this.s3_base_path = this.server_state_info.S3_BASE_PATH || '';
                    this.s3_cloud_path = this.server_state_info.S3_CLOUD_PATH || '';
                    this.websocket_url = this.server_state_info.WEBSOCKET_URL || '';
                    this.apple_rebind_enabled = this.server_state_info.APPLE_REBIND_ENABLED || 'N';
                    this.min_save_limit_enabled = this.server_state_info.MIN_SAVE_LIMIT_ENABLED || 'N';
                    // 전면광고 관리 — 플레이스먼트별 광고 타입 (묶음 객체에서 불러오기)
                    // 신규: INTERSTITIAL_AD_PLACEMENTS 객체 우선, 없으면 과거 루트 저장값 fallback
                    const adPlacements = this.server_state_info.INTERSTITIAL_AD_PLACEMENTS || {};
                    const pickAdType = (k) => (adPlacements[k] != null ? adPlacements[k] : (this.server_state_info[k] || ''));
                    this.ad_placement_values = {
                        CUP_EVENT:        pickAdType('CUP_EVENT'),
                        FRIEND_GATHER_AI: pickAdType('FRIEND_GATHER_AI'),
                        FRIEND_GATHER:    pickAdType('FRIEND_GATHER'),
                        WALLET_SAVE:      pickAdType('WALLET_SAVE'),
                        OX_SUBMIT:        pickAdType('OX_SUBMIT'),
                        OX_WRONG:         pickAdType('OX_WRONG'),
                        TOKEN_ATTENDANCE: pickAdType('TOKEN_ATTENDANCE'),
                        TOKEN_SAVE:       pickAdType('TOKEN_SAVE'),
                    };
                    // 데이터 관리 - 부스터 퀘스트 오퍼월 타입 불러오기
                    if (this.server_state_info.BOOSTER_QUEST_OFFERWALL_TYPES) {
                        this.boosterQuestOfferwallTypes = JSON.parse(JSON.stringify(this.server_state_info.BOOSTER_QUEST_OFFERWALL_TYPES));
                    }
                } catch (error) {
                    console.error('JSON 파일 가져오기 실패:', error);
                }
            },
            MakeSettingData_Json()
            {//서버 데이터를 json으로 변경후 반환한다 
                let result_server_state = {
                    "PACKAGE": "io.snapplay.cpu",
                    "NAME":"코인 채굴기",
                    "VERSION_AOS": this.aosVer,
                    "VERSION_IOS": this.iosVer,
                    
                    "VERSION_AOS_MIN":this.aosVer_Min,
                    "VERSION_IOS_MIN":this.iosVer_Min,

                    "CHECK_VERSION_AOS": this.aosVer_Check,
                    "CHECK_VERSION_IOS": this.iosVer_Check,
                    
                    "SERVER_STATE_AOS": this.selected_server_state_aos,
                    "SERVER_STATE_IOS": this.selected_server_state_ios,
                    "SERVER_CHECKING_MSG": this.server_checking_message,                    
                    "SERVICE_OPTION": {
                        "item_opt": [
                                    {
                                    "key": "10001",
                                    "name": "CPU 증가 보너스 포인트"
                                    }
                                ]
                    },
                    // 옛 호환 — LINK 타입일 때만 LINK 채움, THUMB 은 항상 info.thumb 동기화
                    "ACTIVATION_EVENT_LINK": (this.activation_event_info.action_type === 'LINK')
                        ? (this.activation_event_info.param || '')
                        : (this.activation_event_link || ''),
                    "ACTIVATION_EVENT_THUMB": this.activation_event_info.thumb || this.activation_event_thumb || '',
                    // 신규 통합 객체
                    "ACTIVATION_EVENT_INFO": {
                        is_active:   this.activation_event_info.is_active === 'Y' ? 'Y' : 'N',
                        action_type: this.activation_event_info.action_type || 'LINK',
                        param:       this.activation_event_info.param || '',
                        sub_param:   this.activation_event_info.sub_param || '',
                        thumb:       this.activation_event_info.thumb || '',
                    },
                    "ACTIVATION_EVENT_REVIEW": this.selected_event_state_review,
                    "ACTIVATION_COIN_SHOP":this.activation_coin_shop,
                    "ACTIVATION_MAIN_OFFERWALL_BANNER": this.activation_main_offerwall_banner,
                    "EVENT_OFFERWALL_GUIDE_LIST":this.event_offerwall_guide_list,
                    "SHOP_PRODUCT_TYPE":this.shop_product_type,
                    "SHOP_PRODUCT_TYPE_REVIEW":this.shop_product_type_review,                    
                    "PNJ_COUPON_SHOP_TYPE":this.pnj_coupon_shop_type,
                    "PNJ_COUPON_SHOP_TYPE_REVIEW":this.pnj_coupon_shop_type_review,
                    "VIDEO_AD_COOLTIME":this.video_ad_cooltime,
                    "ENABLE_EVENT_POPUP_START":this.enable_event_popup_start,
                    "REVIEW_EVENT_LINK_AOS":this.review_event_link_aos,
                    "REVIEW_EVENT_LINK_IOS":this.review_event_link_ios,

                    "REVIEW_EVENT_LINK":this.review_event_link_aos,
                    "REVIEW_EVENT_LINK_REVIEW":this.review_event_link_ios,        
                    "OFFERWALL_RECOMMAND_KEY":this.offerwall_recommand_key,
                    "DAILY_PLACEMENT_KEY":this.daily_placement_key,
                    "DAILY_PLACEMENT_GAME_KEY":this.daily_placement_game_key,
                    "DAILY_CHALLENGE_SNAP_PLACEMENT":this.daily_challenge_snap_placement,
                    "DAILY_OFFERWALL_CHALLENGE_COUNT":Number(this.daily_offerwall_challenge_count) || 8,
                    "HOME_API_PLACEMENT":this.home_api_placement,
                    "BACKGROUND_TIMER":this.background_timer,
                    "MALLPIE_ENABLE_STATE":this.mallpie_enable_state,
                    "TUTORIAL_ACTIVATION_TIME": (this.tutorial_activation_datetime || '').trim(),
                    
                    // 포인트탭 관리
                    "SIMPLE_MISSION_LIST": this.simple_mission_list,
                    // RECOMMEND_POINT_PLACEMENT / POINT_TAB_ITEM_LIST(v1) — 미사용으로 제거
                    "POINT_TAB_ITEM_LIST_V2": this.point_tab_item_list_v2,
                    "POINT_TAB_CATEGORY_LIST": this.point_tab_category_list,
                    "POINT_TAB_EVENT_LIST": this.point_tab_event_list,
                    // 메뉴관리 - 오늘의 숙제 리스트
                    // 메뉴관리 - 플레이스먼트
                    "PLACEMENT_LIST": this.placement_list.map((p) => ({ tag: p.tag, placement_key: p.placement_key, count: p.count, description: p.description })),
                    "HOMEWORK_LIST": this.homework_list,
                    "STAMP_EVENT_OFFERWALL_LIST": this.stamp_event_offerwall_list,
                    // 메인페이지 서브 메뉴 관리
                    "MAIN_SUBMENU_LIST": this.main_submenu_list,
                    // 데이터 관리 - 부스터 퀘스트 오퍼월 타입
                    "BOOSTER_QUEST_OFFERWALL_TYPES": this.boosterQuestOfferwallTypes,
                    "COUPANG_BANNER_LINK": this.coupang_banner_link,
                    "PHONE_VERIFY_EMAIL": this.phone_verify_email,
                    "INQUIRY_EMAIL": this.inquiry_email,
                    "S3_BASE_PATH": this.s3_base_path,
                    "S3_CLOUD_PATH": this.s3_cloud_path,
                    "WEBSOCKET_URL": this.websocket_url,
                    "APPLE_REBIND_ENABLED": this.apple_rebind_enabled,
                    "MIN_SAVE_LIMIT_ENABLED": this.min_save_limit_enabled,
                    // 전면광고 관리 — 플레이스먼트별 광고 타입 (하나의 객체로 묶어 저장)
                    "INTERSTITIAL_AD_PLACEMENTS": { ...this.ad_placement_values },
                    // 채굴탭 행성 링크 이벤트
                    "MINING_PLANET_LINK_EVENT": {
                        is_active:   this.mining_planet_link_event.is_active === 'Y' ? 'Y' : 'N',
                        action_type: this.mining_planet_link_event.action_type || 'LINK',
                        param:       this.mining_planet_link_event.param || '',
                        sub_param:   this.mining_planet_link_event.sub_param || '',
                        thumb:       this.mining_planet_link_event.thumb || '',
                        start_date:  this.mining_planet_link_event.start_date || '',
                        end_date:    this.mining_planet_link_event.end_date || '',
                    }

                };
                return result_server_state;     
            },
            IsActiveState(_item) {
                return _item.active_yn == "Y"
                    ? true
                    : false;
            },
            async OnSaveDone() {
                // 강제 업데이트(최소버전) 값이 변경되면 한 번 더 확인 (실수 방지)
                {
                    const _o = this._origForceVer || { aos: '', ios: '' };
                    const _ca = String(this.aosVer_Min == null ? '' : this.aosVer_Min).trim();
                    const _ci = String(this.iosVer_Min == null ? '' : this.iosVer_Min).trim();
                    if (String(_o.aos).trim() !== _ca || String(_o.ios).trim() !== _ci) {
                        if (!confirm('⚠️ 강제 업데이트(최소) 버전이 변경되었습니다.\n\nAOS: ' + (_o.aos || '(없음)') + ' → ' + (_ca || '(없음)') + '\niOS: ' + (_o.ios || '(없음)') + ' → ' + (_ci || '(없음)') + '\n\n이 버전 미만 유저는 강제 업데이트됩니다. 정말 저장하시겠습니까?')) {
                            return;
                        }
                    }
                    this._origForceVer = { aos: _ca, ios: _ci };
                }
                //this.event_offerwall_guide_list = this.server_state_info.EVENT_OFFFERWALL_GUIDE_LIST || [{ placement: '', grade: '', reward: '' }];
                //this.event_offerwall_guide_list 
                //event_thumb_ImageFile
                

                    if(this.event_thumb_ImageFile != null) {
                        const newThumbKey = "mandoora/coin/images/"+this.Utill_CreateNewImageName(this.event_thumb_ImageFile.name);
                        const awaitResult = await FileUpload_Async(this.event_thumb_ImageFile, newThumbKey);
                        // 옛/신규 양쪽 다 동기화
                        this.activation_event_thumb = newThumbKey;
                        this.activation_event_info.thumb = newThumbKey;
                    }

                    // 채굴탭 행성 링크 이벤트 아이콘 업로드
                    if (this.mining_planet_link_event_ImageFile != null) {
                        const mpeThumbKey = "mandoora/coin/images/"+this.Utill_CreateNewImageName(this.mining_planet_link_event_ImageFile.name);
                        await FileUpload_Async(this.mining_planet_link_event_ImageFile, mpeThumbKey);
                        this.mining_planet_link_event.thumb = mpeThumbKey;
                    }
                    
                    // 저장 전 비활성화 항목을 아래로 정렬
                    this.simple_mission_list.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.point_tab_item_list.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.point_tab_item_list_v2.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    this.main_submenu_list.sort((a, b) => {
                        if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                        if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                        return 0;
                    });
                    
                    const json_container = this.MakeSettingData_Json();
                    ///주성 파일 올리는것부터 하면 될듯 
                    console.log("저장:"+JSON.stringify(json_container));
                    this.loadingData = true;
                    var file_path = config.isLive?"mandoora/manage/live/ServerState.json":"mandoora/manage/dev/ServerState.json"
                    if(await FileUpload_JSON(json_container, file_path))
                    {
                        this.loadingData = false;
                        //let commit_path = file_path;
                        console.log(`s3 서버에 저장 되었습니다. ${file_path}`);
                        // 설정 반영을 위해 setting_data_refresh 호출 (CORS 회피를 위해 CMS 백엔드 경유)
                        try {
                            const refreshUrl = `${config.getBackendUrl}/api/mandoora/setting_data_refresh`;
                            const refreshRes = await axios.post(refreshUrl, { is_live: config.isLive });
                            console.log('[setting_data_refresh] 호출 결과:', refreshRes.data);
                        } catch (err) {
                            console.warn('[setting_data_refresh] 호출 실패:', err?.response?.data ?? err.message);
                        }
                        alert("저장완료");
                    }
            },
            OnUserKick() {
                let result = confirm("유저킥을 실행하시는경우 접속중인 유저의 세션이 끊어져 재접속이 될 수 있습니다.",);
                if (result) {
                    alert("유저킥 아직 지원하지 않는 기능입니다.");
                }
            },
            OnResetServer() {
                let packageName = this.$store.state.selected_game_package;
                if (confirm(`[[-->  ${packageName}  <--]]     
                서버의 모든 유저데이터를 지웁니다. 신중하게 결정했습니까?`)) {                    
                    this
                        .DELETE_USER_ALL({packageName})
                        .then((body_data) => {
                            alert("완료");
                        });
                }
            },
            Refresh_ItemInfo() {},
            IsSever_Checking() {
                if (this.selected_server_state_ios == '2' || this.selected_server_state_aos == '2') 
                    return true;
                else 
                    return false;
            },
            clickGetServerTimeBtn() {
                console.log('서버시간 가져오기 클릭됨')
                this.getServerTime()
            },
            clickApplyServerTimeBtn() {
                console.log('서버시간 적용하기 클릭됨')
                console.log(this.dateTime)
                this.setServerTime()
            },
            clickRollbackServerTimeBtn() {
                console.log('서버시간 되돌리기 클릭됨')
                this.rollBackServerTime()
            },
            async getServerTime () {
            },
            async setServerTime () {
            },
            async rollBackServerTime () {
            },
            addOfferwallGuide_Count(){
                this.event_offerwall_guide_list_count++;
                this.event_offerwall_guide_list.push({ placement: '', grade: '', reward: '' });
            },
            removeOfferwallGuide(index){
                this.event_offerwall_guide_list.splice(index, 1);
                this.event_offerwall_guide_list_count = this.event_offerwall_guide_list.length;
            },
            Utill_CreateNewImageName(originalFileName)
            { // 확장자 추출
                const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
                // 랜덤 문자열 생성 (16자)
                const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
                // 새 파일 이름 생성
                return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
            },
            handleFileChange(file)
            {
                this.event_thumb_ImageFile = file;
            },
            // 채굴탭 행성 링크 이벤트: 오퍼월로 바꾸면 목록에 없는 잔여 param 을 비운다
            // (@change 는 사용자 조작에만 발동 → 불러오기에는 영향 없음)
            onMiningActionTypeChange(newType) {
                if (newType === 'OFFERWALL' && !this.offerwall_key_options.includes(this.mining_planet_link_event.param)) {
                    this.mining_planet_link_event.param = '';
                }
            },
            // 포인트탭 관리 메서드
            openPointTabItemDialog() {
                this.editingPointTabItem = { name: '', tag: '', is_active: 'Y' };
                this.editingPointTabItemIndex = -1;
                this.pointTabItemDialog = true;
            },
            editPointTabItem(index) {
                this.editingPointTabItem = { ...this.point_tab_item_list[index] };
                this.editingPointTabItemIndex = index;
                this.pointTabItemDialog = true;
            },
            closePointTabItemDialog() {
                this.pointTabItemDialog = false;
                this.editingPointTabItem = { name: '', tag: '', is_active: 'Y' };
                this.editingPointTabItemIndex = -1;
            },
            savePointTabItem() {
                if (!this.editingPointTabItem.name || !this.editingPointTabItem.name.trim()) {
                    alert('이름을 입력해주세요.');
                    return;
                }
                
                if (this.editingPointTabItemIndex >= 0) {
                    // 수정
                    this.$set(this.point_tab_item_list, this.editingPointTabItemIndex, { ...this.editingPointTabItem });
                } else {
                    // 추가
                    const newItem = {
                        id: Date.now().toString(),
                        name: this.editingPointTabItem.name,
                        tag: this.editingPointTabItem.tag || '',
                        is_active: this.editingPointTabItem.is_active || 'Y'
                    };
                    this.point_tab_item_list.push(newItem);
                }
                this.closePointTabItemDialog();
            },
            deletePointTabItem(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.point_tab_item_list.splice(index, 1);
                }
            },
            togglePointTabItemActive(index) {
                const item = this.point_tab_item_list[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.point_tab_item_list, index, item);
            },
            onPointTabItemDragEnd() {
                // 드래그 앤 드롭 완료 후 순서 저장
                console.log('포인트탭 아이템 순서 변경됨');
            },
            // 포인트탭 V2 관리 메서드
            openPointTabItemDialogV2() {
                this.editingPointTabItemV2 = { name: '', tag: '', icon: '', iconFile: null, placement_key: '', is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' };
                this.editingPointTabItemIndexV2 = -1;
                this.pointTabItemDialogV2 = true;
            },
            editPointTabItemV2(index) {
                const src = this.point_tab_item_list_v2[index] || {};
                this.editingPointTabItemV2 = {
                    ...src,
                    icon: src.icon || '',
                    iconFile: null,
                    placement_key: src.placement_key || '',
                    is_event_mode: src.is_event_mode || 'N',
                    event_start: src.event_start || '',
                    event_end: src.event_end || '',
                };
                this.editingPointTabItemIndexV2 = index;
                this.pointTabItemDialogV2 = true;
            },
            closePointTabItemDialogV2() {
                this.pointTabItemDialogV2 = false;
                this.editingPointTabItemV2 = { name: '', tag: '', icon: '', iconFile: null, placement_key: '', is_active: 'Y', is_event_mode: 'N', event_start: '', event_end: '' };
                this.editingPointTabItemIndexV2 = -1;
            },
            async savePointTabItemV2() {
                if (!this.editingPointTabItemV2.name || !this.editingPointTabItemV2.name.trim()) {
                    alert('이름을 입력해주세요.');
                    return;
                }
                // 아이콘 파일이 있으면 업로드 후 경로 저장 (간단미션과 동일 방식)
                if (this.editingPointTabItemV2.iconFile != null) {
                    const iconPath = "mandoora/coin/images/"+this.Utill_CreateNewImageName(this.editingPointTabItemV2.iconFile.name);
                    await FileUpload_Async(this.editingPointTabItemV2.iconFile, iconPath);
                    this.editingPointTabItemV2.icon = iconPath;
                }

                if (this.editingPointTabItemIndexV2 >= 0) {
                    this.$set(this.point_tab_item_list_v2, this.editingPointTabItemIndexV2, { ...this.editingPointTabItemV2, iconFile: null });
                } else {
                    const newItem = {
                        id: 'v2-' + Date.now().toString(),
                        name: this.editingPointTabItemV2.name,
                        tag: this.editingPointTabItemV2.tag || '',
                        icon: this.editingPointTabItemV2.icon || '',
                        placement_key: this.editingPointTabItemV2.placement_key || '',
                        is_active: this.editingPointTabItemV2.is_active || 'Y',
                        is_event_mode: this.editingPointTabItemV2.is_event_mode || 'N',
                        event_start: this.editingPointTabItemV2.event_start || '',
                        event_end: this.editingPointTabItemV2.event_end || ''
                    };
                    this.point_tab_item_list_v2.push(newItem);
                }
                this.closePointTabItemDialogV2();
            },
            deletePointTabItemV2(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.point_tab_item_list_v2.splice(index, 1);
                }
            },
            togglePointTabItemActiveV2(index) {
                const item = this.point_tab_item_list_v2[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.point_tab_item_list_v2, index, item);
            },
            togglePointTabItemEventModeV2(index) {
                const item = { ...this.point_tab_item_list_v2[index] };
                item.is_event_mode = item.is_event_mode === 'Y' ? 'N' : 'Y';
                this.$set(this.point_tab_item_list_v2, index, item);
            },
            // 이벤트 모드가 켜져있어도, 기간(시작/종료)이 제대로 설정되고 현재 시각이 그 안일 때만 ON.
            // 시작 또는 종료가 미설정/무효이면 리스트에서는 OFF로 본다.
            isV2EventActiveNow(item) {
                // 이벤트 모드 ON/OFF 와 무관하게, 설정된 기간(날짜)만으로 활성 여부를 판단한다.
                if (!item || !item.event_start || !item.event_end) return false;
                const s = new Date(String(item.event_start).replace(' ', 'T'));
                const e = new Date(String(item.event_end).replace(' ', 'T'));
                if (isNaN(s.getTime()) || isNaN(e.getTime())) return false;
                const now = new Date();
                if (now < s || now > e) return false;
                return true;
            },
            // 이벤트 기간(날짜) 기준 상태: NONE(미설정) / UPCOMING(예정) / ONGOING(진행중) / ENDED(종료)
            getV2EventStatus(item) {
                if (!item || !item.event_start || !item.event_end) return 'NONE';
                const s = new Date(String(item.event_start).replace(' ', 'T'));
                const e = new Date(String(item.event_end).replace(' ', 'T'));
                if (isNaN(s.getTime()) || isNaN(e.getTime())) return 'NONE';
                const now = new Date();
                if (now < s) return 'UPCOMING';   // 시작 전 → 예정
                if (now > e) return 'ENDED';      // 종료 후 → 종료
                return 'ONGOING';                 // 기간 내 → 진행중
            },
            getV2EventStatusText(item) {
                switch (this.getV2EventStatus(item)) {
                    case 'UPCOMING': return '이벤트 예정!';
                    case 'ONGOING':  return '이벤트중!';
                    case 'ENDED':    return '이벤트 종료!';
                    default:         return '';
                }
            },
            // 칩 표시용 { text, color, textColor, icon } — 미설정이면 null
            getV2EventStatusChip(item) {
                switch (this.getV2EventStatus(item)) {
                    case 'UPCOMING': return { text: '이벤트 예정!', color: 'blue lighten-4', textColor: 'blue darken-3', icon: 'mdi-calendar-clock' };
                    case 'ONGOING':  return { text: '이벤트중!',   color: 'pink lighten-4', textColor: 'pink darken-3', icon: 'mdi-calendar-star' };
                    case 'ENDED':    return { text: '이벤트 종료!', color: 'grey lighten-2', textColor: 'grey darken-1', icon: 'mdi-calendar-remove' };
                    default:         return null;
                }
            },
            formatEventPeriod(item) {
                const fmt = (v) => (v ? String(v).replace('T', ' ') : '미설정');
                return `${fmt(item.event_start)} ~ ${fmt(item.event_end)}`;
            },
            // date/time 피커 값을 합쳐 'YYYY-MM-DD HH:mm:ss' 로 저장. 날짜 없으면 비움, 시간 없으면 00:00:00.
            _setEventPart(objName, field, dateVal, timeVal) {
                const obj = this[objName];
                const cur = (obj[field] || '').replace('T', ' ');
                const parts = cur.split(' ');
                let d = parts[0] || '';
                let t = parts[1] || '';
                if (dateVal !== null && dateVal !== undefined) d = dateVal;
                if (timeVal !== null && timeVal !== undefined) t = timeVal;
                if (!d) { this.$set(obj, field, ''); return; }
                const tp = (t || '').split(':');
                const hh = (tp[0] || '00').padStart(2, '0');
                const mm = (tp[1] || '00').padStart(2, '0');
                const ss = (tp[2] || '00').padStart(2, '0');
                this.$set(obj, field, d + ' ' + hh + ':' + mm + ':' + ss);
            },
            clearV2Event(field) {
                this.$set(this.editingPointTabItemV2, field, '');
            },
            onPointTabItemDragEndV2() {
                console.log('포인트탭 V2 아이템 순서 변경됨');
            },
            // ===== 카테고리 관리 =====
            openCategoryDialog(index) {
                if (index === undefined || index === null || index < 0) {
                    this.editingCategory = { name: '', description: '' };
                    this.editingCategoryIndex = -1;
                } else {
                    const c = this.point_tab_category_list[index] || {};
                    this.editingCategory = { name: c.name || '', description: c.description || '' };
                    this.editingCategoryIndex = index;
                }
                this.categoryDialog = true;
            },
            closeCategoryDialog() {
                this.categoryDialog = false;
                this.editingCategory = { name: '', description: '' };
                this.editingCategoryIndex = -1;
            },
            saveCategory() {
                const name = (this.editingCategory.name || '').trim();
                if (!name) { alert('카테고리 이름을 입력해주세요.'); return; }
                const desc = (this.editingCategory.description || '').trim();
                if (this.editingCategoryIndex >= 0) {
                    const c = { ...this.point_tab_category_list[this.editingCategoryIndex], name, description: desc };
                    this.$set(this.point_tab_category_list, this.editingCategoryIndex, c);
                } else {
                    this.point_tab_category_list.push({
                        id: 'cat-' + Date.now().toString(),
                        name,
                        description: desc,
                        items: [],
                    });
                }
                this.closeCategoryDialog();
            },
            deleteCategory(index) {
                if (confirm('이 카테고리를 삭제하시겠습니까? (강화소 연결만 사라지고 강화소 자체는 V2에 유지됩니다)')) {
                    this.point_tab_category_list.splice(index, 1);
                }
            },
            // 강화소(V2) 조회 — 카테고리는 id 만 저장하고 정보는 V2 에서 가져온다
            lookupV2Item(id) {
                return this.point_tab_item_list_v2.find((it) => it.id === id) || null;
            },
            lookupV2Name(id) {
                const it = this.lookupV2Item(id);
                return it ? (it.name || '(이름 없음)') : '(삭제된 강화소)';
            },
            // 이 카테고리에 아직 없는 V2 강화소 목록 (선택용)
            availableV2Items(cidx) {
                const cat = this.point_tab_category_list[cidx] || {};
                const used = new Set(cat.items || []);
                return this.point_tab_item_list_v2
                    .filter((it) => it.id && !used.has(it.id))
                    .map((it) => ({
                        id: it.id,
                        label: (it.name || '(이름 없음)')
                            + (it.tag ? ' · ' + it.tag : '')
                            + (it.placement_key ? ' · [' + it.placement_key + ']' : ''),
                    }));
            },
            addItemToCategory(cidx) {
                const sel = this.addItemSelection[cidx];
                if (!sel) return;
                const cat = this.point_tab_category_list[cidx];
                if (!cat) return;
                if (!Array.isArray(cat.items)) this.$set(cat, 'items', []);
                if (!cat.items.includes(sel)) cat.items.push(sel);
                this.$set(this.addItemSelection, cidx, null);
            },
            removeItemFromCategory(cidx, iidx) {
                const cat = this.point_tab_category_list[cidx];
                if (cat && Array.isArray(cat.items)) cat.items.splice(iidx, 1);
            },
            onCategoryDragEnd() {
                console.log('카테고리/강화소 순서 변경됨');
            },
            // ===== 이벤트 리스트 관리 (오퍼월 아이템 1개만 선택) =====
            openEventDialog(index) {
                if (index === undefined || index === null || index < 0) {
                    this.editingEvent = { name: '', description: '', item_id: null };
                    this.editingEventIndex = -1;
                } else {
                    const e = this.point_tab_event_list[index] || {};
                    this.editingEvent = { name: e.name || '', description: e.description || '', item_id: e.item_id || null };
                    this.editingEventIndex = index;
                }
                this.eventDialog = true;
            },
            closeEventDialog() {
                this.eventDialog = false;
                this.editingEvent = { name: '', description: '', item_id: null };
                this.editingEventIndex = -1;
            },
            saveEvent() {
                const name = (this.editingEvent.name || '').trim();
                if (!name) { alert('이벤트 이름을 입력해주세요.'); return; }
                const desc = (this.editingEvent.description || '').trim();
                const item_id = this.editingEvent.item_id || null;
                if (this.editingEventIndex >= 0) {
                    const e = { ...this.point_tab_event_list[this.editingEventIndex], name, description: desc, item_id };
                    this.$set(this.point_tab_event_list, this.editingEventIndex, e);
                } else {
                    this.point_tab_event_list.push({ id: 'ev-' + Date.now().toString(), name, description: desc, item_id });
                }
                this.closeEventDialog();
            },
            deleteEvent(index) {
                if (confirm('이 이벤트를 삭제하시겠습니까? (오퍼월 아이템 연결만 사라지고 아이템 자체는 V2에 유지됩니다)')) {
                    this.point_tab_event_list.splice(index, 1);
                }
            },
            // ===== 메뉴관리 - 오늘의 숙제 리스트 =====
            homeworkTypeLabel(type) {
                const m = { CUSTOM: '커스텀', OFFERWALL: '오퍼월', LINK: '링크' };
                return m[type] || type || '-';
            },
            homeworkTypeChipColor(type) {
                const m = { CUSTOM: 'deep-purple', OFFERWALL: 'teal', LINK: 'blue-grey' };
                return m[type] || 'grey';
            },
            openHomeworkDialog(index) {
                if (index === undefined || index < 0) {
                    this.editingHomework = { thumb: '', thumbFile: null, title: '', campaign_key: '', type: 'CUSTOM', custom_key: '', offerwall_type: '', placement_key: '', link_url: '' };
                    this.editingHomeworkIndex = -1;
                } else {
                    const h = this.homework_list[index] || {};
                    this.editingHomework = {
                        thumb: h.thumb || '',
                        thumbFile: null,
                        title: h.title || '',
                        type: h.type || 'CUSTOM',
                        custom_key: h.custom_key || '',
                        offerwall_type: h.offerwall_type || '',
                        placement_key: h.placement_key || '',
                        campaign_key: h.campaign_key || '',
                        link_url: h.link_url || '',
                    };
                    this.editingHomeworkIndex = index;
                }
                this.homeworkDialog = true;
            },
            closeHomeworkDialog() {
                this.homeworkDialog = false;
                this.editingHomework = { thumb: '', thumbFile: null, title: '', campaign_key: '', type: 'CUSTOM', custom_key: '', offerwall_type: '', placement_key: '', link_url: '' };
                this.editingHomeworkIndex = -1;
            },
            async saveHomework() {
                const title = (this.editingHomework.title || '').trim();
                if (!title) { alert('타이틀을 입력해주세요.'); return; }
                const type = this.editingHomework.type || 'CUSTOM';
                // 타입별 검증
                if (type === 'CUSTOM') {
                    const key = (this.editingHomework.custom_key || '').trim();
                    if (!key) { alert('커스텀 숙제는 고유 키값을 입력해주세요.'); return; }
                    // 커스텀 간 고유키 중복 검사 (자기 자신 제외)
                    const dup = this.homework_list.some((h, i) => i !== this.editingHomeworkIndex && h.type === 'CUSTOM' && (h.custom_key || '').trim() === key);
                    if (dup) { alert('커스텀 고유 키값 "' + key + '" 이(가) 이미 존재합니다. 커스텀 숙제 간에는 중복될 수 없습니다.'); return; }
                } else if (type === 'OFFERWALL') {
                    if (!this.editingHomework.offerwall_type) { alert('오퍼월 타입을 선택해주세요.'); return; }
                } else if (type === 'LINK') {
                    if (!(this.editingHomework.link_url || '').trim()) { alert('링크 주소를 입력해주세요.'); return; }
                }
                // 썸네일 업로드 (V2 아이콘과 동일 방식)
                if (this.editingHomework.thumbFile != null) {
                    const thumbPath = "mandoora/coin/images/" + this.Utill_CreateNewImageName(this.editingHomework.thumbFile.name);
                    await FileUpload_Async(this.editingHomework.thumbFile, thumbPath);
                    this.editingHomework.thumb = thumbPath;
                }
                // 타입에 따라 무관한 필드는 비워서 저장 (데이터 오염 방지)
                const built = {
                    thumb: this.editingHomework.thumb || '',
                    title,
                    type,
                    custom_key: type === 'CUSTOM' ? (this.editingHomework.custom_key || '').trim() : '',
                    offerwall_type: type === 'OFFERWALL' ? (this.editingHomework.offerwall_type || '') : '',
                    placement_key: type === 'OFFERWALL' ? (this.editingHomework.placement_key || '').trim() : '',
                    campaign_key: type === 'OFFERWALL' ? (this.editingHomework.campaign_key || '').trim() : '',
                    link_url: type === 'LINK' ? (this.editingHomework.link_url || '').trim() : '',
                };
                if (this.editingHomeworkIndex >= 0) {
                    const merged = { ...this.homework_list[this.editingHomeworkIndex], ...built };
                    this.$set(this.homework_list, this.editingHomeworkIndex, merged);
                } else {
                    this.homework_list.push({ id: 'hw-' + Date.now().toString(), ...built });
                }
                this.closeHomeworkDialog();
            },
            // ===== 메뉴관리 - 플레이스먼트 =====
            openPlacementDialog(index) {
                if (index === undefined || index < 0) {
                    this.editingPlacement = { tag: '', placement_key: '', count: -1, description: '' };
                    this.editingPlacementIndex = -1;
                } else {
                    const p = this.placement_list[index] || {};
                    this.editingPlacement = { tag: p.tag || '', placement_key: p.placement_key || '', count: p.count, description: p.description || '' };
                    this.editingPlacementIndex = index;
                }
                this.placementDialog = true;
            },
            closePlacementDialog() {
                this.placementDialog = false;
                this.editingPlacement = { tag: '', placement_key: '', count: -1, description: '' };
                this.editingPlacementIndex = -1;
            },
            savePlacement() {
                const placement_key = (this.editingPlacement.placement_key || '').trim();
                const description = (this.editingPlacement.description || '').trim();
                const rawCount = this.editingPlacement.count;
                const count = (rawCount === '' || rawCount === null || rawCount === undefined) ? -1 : Number(rawCount);
                if (!Number.isInteger(count)) { alert('카운트는 정수로 입력해주세요.'); return; }
                if (this.editingPlacementIndex >= 0) {
                    // 수정: 태그는 그대로, 키·설명만 변경
                    const cur = this.placement_list[this.editingPlacementIndex];
                    this.$set(this.placement_list, this.editingPlacementIndex, { ...cur, placement_key, count, description });
                } else {
                    const tag = (this.editingPlacement.tag || '').trim().toUpperCase();
                    if (!tag) { alert('태그를 입력해주세요.'); return; }
                    if (this.placement_list.some((p) => p.tag === tag)) { alert('이미 등록된 태그입니다: ' + tag + '\n태그는 중복될 수 없어 추가하지 않습니다.'); return; }
                    this.placement_list.push({ tag, placement_key, count, description });
                }
                this.closePlacementDialog();
            },
            deleteHomework(index) {
                if (confirm('이 숙제를 삭제하시겠습니까?')) {
                    this.homework_list.splice(index, 1);
                }
            },
            // 이벤트 아이템 선택용 — 전체 V2 강화소 옵션(하나 선택)
            v2ItemOptions() {
                return this.point_tab_item_list_v2
                    .filter((it) => it.id)
                    .map((it) => ({
                        id: it.id,
                        label: (it.name || '(이름 없음)')
                            + (it.tag ? ' · ' + it.tag : '')
                            + (it.placement_key ? ' · [' + it.placement_key + ']' : ''),
                    }));
            },
            // ===== 스탬프이벤트 관리 (강화소 V2에서 선택) =====
            availableStampV2Items() {
                const used = new Set(this.stamp_event_offerwall_list.map((o) => o.id));
                return this.point_tab_item_list_v2
                    .filter((it) => it.id && !used.has(it.id))
                    .map((it) => ({
                        id: it.id,
                        label: (it.name || '(이름 없음)')
                            + (it.tag ? ' · ' + it.tag : '')
                            + (it.placement_key ? ' · [' + it.placement_key + ']' : ''),
                    }));
            },
            addStampOfferwall() {
                const id = this.newStampSelection;
                if (!id) return;
                if (this.stamp_event_offerwall_list.some((o) => o.id === id)) {
                    alert('이미 추가된 강화소입니다.');
                    return;
                }
                this.stamp_event_offerwall_list.push({ id, is_active: 'Y' });
                this.newStampSelection = null;
            },
            removeStampOfferwall(index) {
                if (confirm('이 오퍼월을 스탬프이벤트에서 제외하시겠습니까?')) {
                    this.stamp_event_offerwall_list.splice(index, 1);
                }
            },
            toggleStampOfferwallActive(index) {
                const o = { ...this.stamp_event_offerwall_list[index] };
                o.is_active = o.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.stamp_event_offerwall_list, index, o);
            },
            // 간단미션 관리 메서드
            openSimpleMissionDialog() {
                this.editingSimpleMission = { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' };
                this.editingSimpleMissionIndex = -1;
                this.simpleMissionDialog = true;
            },
            editSimpleMission(index) {
                this.editingSimpleMission = { 
                    ...this.simple_mission_list[index],
                    iconFile: null 
                };
                this.editingSimpleMissionIndex = index;
                this.simpleMissionDialog = true;
            },
            closeSimpleMissionDialog() {
                this.simpleMissionDialog = false;
                this.editingSimpleMission = { icon: '', iconFile: null, title: '', placement: '', description: '', is_active: 'Y' };
                this.editingSimpleMissionIndex = -1;
            },
            async saveSimpleMission() {
                if (!this.editingSimpleMission.title || !this.editingSimpleMission.title.trim()) {
                    alert('타이틀을 입력해주세요.');
                    return;
                }
                
                // 아이콘 파일이 있으면 업로드
                if (this.editingSimpleMission.iconFile != null) {
                    const iconPath = "mandoora/coin/images/"+this.Utill_CreateNewImageName(this.editingSimpleMission.iconFile.name);
                    await FileUpload_Async(this.editingSimpleMission.iconFile, iconPath);
                    this.editingSimpleMission.icon = iconPath;
                }
                
                if (this.editingSimpleMissionIndex >= 0) {
                    // 수정
                    this.$set(this.simple_mission_list, this.editingSimpleMissionIndex, { 
                        ...this.editingSimpleMission,
                        iconFile: null 
                    });
                } else {
                    // 추가
                    const newItem = {
                        id: Date.now().toString(),
                        icon: this.editingSimpleMission.icon || '',
                        title: this.editingSimpleMission.title,
                        placement: this.editingSimpleMission.placement || '',
                        description: this.editingSimpleMission.description || '',
                        is_active: this.editingSimpleMission.is_active || 'Y'
                    };
                    this.simple_mission_list.push(newItem);
                }
                this.closeSimpleMissionDialog();
            },
            deleteSimpleMission(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.simple_mission_list.splice(index, 1);
                }
            },
            toggleSimpleMissionActive(index) {
                const item = this.simple_mission_list[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.simple_mission_list, index, item);
                // 비활성화 항목을 아래로 정렬
                this.simple_mission_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
            },
            onSimpleMissionDragEnd() {
                // 드래그 앤 드롭 완료 후 비활성화 항목을 아래로 정렬
                this.simple_mission_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
                console.log('간단미션 순서 변경됨');
            },
            handleSimpleMissionIconChange(file) {
                this.editingSimpleMission.iconFile = file;
            },
            // 메인페이지 서브 메뉴 관리 메서드
            openMainSubmenuDialog() {
                this.editingMainSubmenu = { icon: '', iconFile: null, title: '', tag: '', type: 'LINK', path: '', is_active: 'Y' };
                this.editingMainSubmenuIndex = -1;
                this.mainSubmenuDialog = true;
            },
            editMainSubmenu(index) {
                this.editingMainSubmenu = {
                    ...this.main_submenu_list[index],
                    iconFile: null
                };
                this.editingMainSubmenuIndex = index;
                this.mainSubmenuDialog = true;
            },
            closeMainSubmenuDialog() {
                this.mainSubmenuDialog = false;
                this.editingMainSubmenu = { icon: '', iconFile: null, title: '', tag: '', type: 'LINK', path: '', is_active: 'Y' };
                this.editingMainSubmenuIndex = -1;
            },
            async saveMainSubmenu() {
                if (!this.editingMainSubmenu.title || !this.editingMainSubmenu.title.trim()) {
                    alert('타이틀을 입력해주세요.');
                    return;
                }
                
                // 아이콘 파일이 있으면 업로드
                if (this.editingMainSubmenu.iconFile != null) {
                    const iconPath = "mandoora/coin/images/"+this.Utill_CreateNewImageName(this.editingMainSubmenu.iconFile.name);
                    await FileUpload_Async(this.editingMainSubmenu.iconFile, iconPath);
                    this.editingMainSubmenu.icon = iconPath;
                }
                
                if (this.editingMainSubmenuIndex >= 0) {
                    // 수정
                    this.$set(this.main_submenu_list, this.editingMainSubmenuIndex, {
                        ...this.editingMainSubmenu,
                        iconFile: null
                    });
                } else {
                    // 추가
                    const newItem = {
                        id: Date.now().toString(),
                        icon: this.editingMainSubmenu.icon || '',
                        title: this.editingMainSubmenu.title,
                        tag: this.editingMainSubmenu.tag || '',
                        type: this.editingMainSubmenu.type || 'LINK',
                        path: this.editingMainSubmenu.path || '',
                        is_active: this.editingMainSubmenu.is_active || 'Y'
                    };
                    this.main_submenu_list.push(newItem);
                }
                this.closeMainSubmenuDialog();
            },
            deleteMainSubmenu(index) {
                if (confirm('정말 삭제하시겠습니까?')) {
                    this.main_submenu_list.splice(index, 1);
                }
            },
            toggleMainSubmenuActive(index) {
                const item = this.main_submenu_list[index];
                item.is_active = item.is_active === 'Y' ? 'N' : 'Y';
                this.$set(this.main_submenu_list, index, item);
                this.main_submenu_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
            },
            onMainSubmenuDragEnd() {
                this.main_submenu_list.sort((a, b) => {
                    if (a.is_active === 'Y' && b.is_active !== 'Y') return -1;
                    if (a.is_active !== 'Y' && b.is_active === 'Y') return 1;
                    return 0;
                });
                console.log('메인 서브 메뉴 순서 변경됨');
            },
            handleMainSubmenuIconChange(file) {
                this.editingMainSubmenu.iconFile = file;
            },
            // 데이터 관리 - 부스터 퀘스트 메서드
            onFileChange_BoosterQuest(file) {
                const f = Array.isArray(file) ? file[0] : file;
                if (!f) {
                    this.enableUpload_BoosterQuest = false;
                    return;
                }
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        JSON.parse(e.target.result);
                        this.enableUpload_BoosterQuest = true;
                    } catch (err) {
                        alert('JSON 파일 형식이 올바르지 않습니다.');
                        this.enableUpload_BoosterQuest = false;
                    }
                };
                reader.readAsText(f, 'utf-8');
            },
            async upload_BoosterQuest() {
                if (!this.boosterQuestFile) return;
                const filePath = config.isLive
                    ? 'mandoora/data/live/booster_quest.json'
                    : 'mandoora/data/dev/booster_quest.json';
                const reader = new FileReader();
                reader.onload = async (e) => {
                    try {
                        const json = JSON.parse(e.target.result);
                        this.loadingBoosterQuest = true;
                        const success = await FileUpload_JSON(json, filePath);
                        this.loadingBoosterQuest = false;
                        if (success) {
                            try {
                                await axios.post('https://cpuapi.snapplay.io/cpu_only/util/quest_data_refresh');
                                console.log('[quest_data_refresh] 호출 완료');
                            } catch (err) {
                                console.warn('[quest_data_refresh] 호출 실패:', err?.response?.data ?? err.message);
                            }
                            alert('부스터 퀘스트 업로드 완료');
                            this.boosterQuestFile = null;
                            this.enableUpload_BoosterQuest = false;
                        } else {
                            alert('업로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                        }
                    } catch (err) {
                        this.loadingBoosterQuest = false;
                        alert('파일을 읽는 중 오류가 발생했습니다.');
                    }
                };
                reader.readAsText(this.boosterQuestFile, 'utf-8');
            },
            openBoosterQuestLink() {
                const env = config.isLive ? 'live' : 'dev';
                const url = `https://content-filecenter.s3.ap-northeast-2.amazonaws.com/mandoora/data/${env}/booster_quest.json`;
                window.open(url, '_blank');
            },
            addOfferwallType() {
                const val = (this.newOfferwallType || '').trim();
                if (!val) return;
                if (this.boosterQuestOfferwallTypes.includes(val)) {
                    alert('이미 등록된 타입입니다.');
                    return;
                }
                this.boosterQuestOfferwallTypes.push(val);
                this.newOfferwallType = '';
            },
            removeOfferwallType(idx) {
                this.boosterQuestOfferwallTypes.splice(idx, 1);
            },
        },
        computed: {
            // 모바일/태블릿에서는 탭 헤더 대신 드롭다운을 노출한다.
            // (가로 스크롤 중 스와이프가 탭 전환으로 잡히는 문제 방지)
            isMobileTab() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            isLive() {
                return config.isLive;
            },
            serverState_URL () {
                return config.serverState_URL_MANDOORA;
            },
            // 이벤트 시작/종료를 날짜(YYYY-MM-DD) + 시(HH) + 분(mm)으로 분해해 달력/드롭다운에 바인딩.
            // 저장 형식은 'YYYY-MM-DDTHH:mm' 유지. 날짜만 고르면 시간은 기본 00:00.
            hourItems() {
                return Array.from({ length: 24 }, (_, i) => { const v = String(i).padStart(2, '0'); return { text: v + '시', value: v }; });
            },
            minuteItems() {
                return Array.from({ length: 60 }, (_, i) => { const v = String(i).padStart(2, '0'); return { text: v + '분', value: v }; });
            },
            v2StartDate: {
                get() { return (this.editingPointTabItemV2.event_start || '').replace('T', ' ').split(' ')[0] || ''; },
                set(v) { this._setEventPart('editingPointTabItemV2', 'event_start', v, null); },
            },
            v2StartHour: {
                get() { return (((this.editingPointTabItemV2.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; },
                set(v) { const m = (((this.editingPointTabItemV2.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; this._setEventPart('editingPointTabItemV2', 'event_start', null, v + ':' + m); },
            },
            v2StartMin: {
                get() { return (((this.editingPointTabItemV2.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; },
                set(v) { const h = (((this.editingPointTabItemV2.event_start || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; this._setEventPart('editingPointTabItemV2', 'event_start', null, h + ':' + v); },
            },
            v2EndDate: {
                get() { return (this.editingPointTabItemV2.event_end || '').replace('T', ' ').split(' ')[0] || ''; },
                set(v) { this._setEventPart('editingPointTabItemV2', 'event_end', v, null); },
            },
            v2EndHour: {
                get() { return (((this.editingPointTabItemV2.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; },
                set(v) { const m = (((this.editingPointTabItemV2.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; this._setEventPart('editingPointTabItemV2', 'event_end', null, v + ':' + m); },
            },
            v2EndMin: {
                get() { return (((this.editingPointTabItemV2.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[1]) || '00'; },
                set(v) { const h = (((this.editingPointTabItemV2.event_end || '').replace('T', ' ').split(' ')[1] || '00:00:00').split(':')[0]) || '00'; this._setEventPart('editingPointTabItemV2', 'event_end', null, h + ':' + v); },
            },
            computedDateFormattedMomentjs_begin() {
                return this.date_begin
                    ? moment(this.date_begin).format('YYYY-MM-DD')
                    : ''
            },
            computedDateFormattedMomentjs_end() {
                return this.date_end
                    ? moment(this.date_end).format('YYYY-MM-DD')
                    : ''
            },
            dateTime() {
                return this.date + ' ' + this.time1;
            },
            url() {
                return `${this.serverState_URL}?t=${Date.now()}`;
            },
            // 이벤트 안내 — 액션 타입에 따라 param 입력 라벨/플레이스홀더 동적으로 변경
            actionParamLabel() {
                const type = this.activation_event_info && this.activation_event_info.action_type;
                if (type === 'OFFERWALL')  return '오퍼월 키';
                if (type === 'PLACEMENT')  return '플레이스먼트 키';
                if (type === 'CAMPAIGN')   return '캠페인 ID';
                return 'URL';
            },
            actionParamPlaceholder() {
                const type = this.activation_event_info && this.activation_event_info.action_type;
                if (type === 'OFFERWALL')  return '예: snapplay_offerwall';
                if (type === 'PLACEMENT')  return '예: cpu_플레이스먼트1';
                if (type === 'CAMPAIGN')   return '예: 12345';
                return 'https://...';
            },
            miningPlanetParamLabel() {
                const type = this.mining_planet_link_event && this.mining_planet_link_event.action_type;
                if (type === 'OFFERWALL')  return '오퍼월 키';
                if (type === 'PLACEMENT')  return '플레이스먼트 키';
                if (type === 'CAMPAIGN')   return '캠페인 ID';
                return 'URL';
            },
            miningPlanetParamPlaceholder() {
                const type = this.mining_planet_link_event && this.mining_planet_link_event.action_type;
                if (type === 'OFFERWALL')  return '예: snapplay_offerwall';
                if (type === 'PLACEMENT')  return '예: cpu_플레이스먼트1';
                if (type === 'CAMPAIGN')   return '예: 12345';
                return 'https://...';
            },
            miningPlanetSubParamHint() {
                const base = '액션 실행 시 추가로 전달할 부가 파라미터. 비워두면 미사용.';
                const type = this.mining_planet_link_event && this.mining_planet_link_event.action_type;
                if (type === 'CAMPAIGN') return base + ' (스냅캠페인인 경우 플레이스먼트 필요)';
                return base;
            },
        },
        components: {
            draggable
        },
        watch: {
            '$store.state.selected_game_package': function () {
                console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
                this.LoadGameSetting();
                this.getServerTime()
            }
        }

    };
</script>

<style scoped>
.tab-item {
    min-width: 150px;
}

.tab-text {
    font-weight: 500;
    font-size: 0.9rem;
}

.toolbar-custom {
    border-bottom: 1px solid #e0e0e0;
}

.toolbar-title-custom {
    font-size: 1rem;
    font-weight: 600;
    color: #424242;
}

.toolbar-text {
    margin-left: 8px;
}

.drag-handle {
    cursor: move;
}

.drag-handle:hover {
    color: #1976d2 !important;
}

.cat-drag-handle,
.item-drag-handle {
    cursor: move;
}
.cat-drag-handle:hover,
.item-drag-handle:hover {
    color: #00897b !important;
}

.stamp-drag-handle {
    cursor: move;
}
.stamp-drag-handle:hover {
    color: #8e24aa !important;
}

.ev-drag-handle {
    cursor: move;
}
.ev-drag-handle:hover {
    color: #3949ab !important;
}

.point-tab-item-inactive {
    background-color: #f5f5f5 !important;
    opacity: 0.7;
}

.point-tab-item-inactive .v-list-item__title,
.point-tab-item-inactive .v-list-item__subtitle {
    color: #9e9e9e !important;
}

.tab-select {
    max-width: 100%;
    background-color: #fff;
}

@media (max-width: 960px) {
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; }
  .v-tabs { max-width: 100%; }
  .tab-select .tab-text { font-size: 0.875rem; }
}
</style>